/* Generated by ai2react v0.102.0 - 2021-12-20 14:43 */
/* ai file: calidad-de-la-gestion.ai */

import { makeAi2React } from 'ai2react'
import img0 from '././img/calidad-de-la-gestion-large.svg'
import img1 from '././img/calidad-de-la-gestion-mobile.svg'

const styles = `
  #g-calidad-de-la-gestion-box ,
  #g-calidad-de-la-gestion-box .g-artboard {
    margin:0 auto;
  }
  #g-calidad-de-la-gestion-box p {
    margin:0;
  }
  #g-calidad-de-la-gestion-box .g-aiAbs {
    position:absolute;
  }
  #g-calidad-de-la-gestion-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-calidad-de-la-gestion-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-calidad-de-la-gestion-box .g-aiPointText p { white-space: nowrap; }
  #g-calidad-de-la-gestion-large {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-de-la-gestion-large p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:18px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:15px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-calidad-de-la-gestion-large .g-pstyle0 {
    line-height:66px;
    height:66px;
    letter-spacing:-0.019em;
    font-size:55px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle1 {
    font-weight:800;
    line-height:66px;
    height:66px;
    letter-spacing:0em;
    font-size:55px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle2 {
    font-weight:800;
    line-height:66px;
    height:66px;
    letter-spacing:-0.019em;
    font-size:55px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-large .g-pstyle3 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle4 {
    font-weight:800;
    height:18px;
    letter-spacing:-0.019em;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-large .g-pstyle5 {
    line-height:16px;
    height:16px;
    letter-spacing:-0.019em;
    font-size:14px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle6 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:12px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle7 {
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle8 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle9 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.036em;
    font-size:10px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle10 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.041em;
    font-size:10px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle11 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle12 {
    font-weight:800;
    line-height:25px;
    height:25px;
    letter-spacing:0em;
    font-size:20px;
    color:rgb(188,190,192);
  }
  #g-calidad-de-la-gestion-large .g-pstyle13 {
    line-height:15px;
    height:15px;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle14 {
    line-height:16px;
    height:16px;
    letter-spacing:0em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle15 {
    line-height:16px;
    height:16px;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle16 {
    line-height:16px;
    height:16px;
    font-size:13px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-large .g-pstyle17 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.096em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle18 {
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:12px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-large .g-pstyle19 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.03em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle20 {
    line-height:16px;
    height:16px;
    letter-spacing:-0.03em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle21 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.1em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle22 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.092em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle23 {
    font-weight:800;
    line-height:25px;
    height:25px;
    letter-spacing:0em;
    font-size:20px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-large .g-pstyle24 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.101em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle25 {
    font-weight:800;
    line-height:25px;
    height:25px;
    letter-spacing:0em;
    font-size:20px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-de-la-gestion-large .g-pstyle26 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.076em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle27 {
    line-height:16px;
    height:16px;
    letter-spacing:-0.03em;
    font-size:13px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-large .g-pstyle28 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.09em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle29 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.099em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle30 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.124em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle31 {
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-large .g-pstyle32 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.085em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle33 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.098em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle34 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.103em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle35 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.102em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle36 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.089em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle37 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.079em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle38 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.08em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle39 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.107em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle40 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.097em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle41 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.091em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle42 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.108em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle43 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.116em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle44 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.104em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle45 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.117em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle46 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.119em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle47 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.121em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle48 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.106em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle49 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.118em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle50 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.111em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-pstyle51 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.113em;
    font-size:13px;
  }
  #g-calidad-de-la-gestion-large .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle2 {
    letter-spacing:-0.03em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle3 {
    letter-spacing:-0.029em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle4 {
    letter-spacing:-0.047em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle5 {
    letter-spacing:-0.045em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle6 {
    letter-spacing:-0.036em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle7 {
    letter-spacing:-0.101em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle8 {
    letter-spacing:-0.109em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle9 {
    letter-spacing:-0.019em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle10 {
    letter-spacing:-0.053em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle11 {
    letter-spacing:-0.044em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle12 {
    letter-spacing:-0.049em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle13 {
    letter-spacing:-0.086em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle14 {
    letter-spacing:-0.042em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle15 {
    letter-spacing:-0.035em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle16 {
    letter-spacing:-0.039em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle17 {
    letter-spacing:-0.098em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle18 {
    letter-spacing:-0.032em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle19 {
    letter-spacing:-0.043em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle20 {
    letter-spacing:-0.076em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle21 {
    letter-spacing:-0.034em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle22 {
    letter-spacing:-0.041em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle23 {
    letter-spacing:-0.133em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle24 {
    letter-spacing:-0.087em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle25 {
    letter-spacing:-0.105em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle26 {
    letter-spacing:-0.095em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle27 {
    letter-spacing:-0.11em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle28 {
    letter-spacing:-0.117em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle29 {
    letter-spacing:-0.13em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle30 {
    letter-spacing:-0.135em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle31 {
    letter-spacing:-0.038em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle32 {
    letter-spacing:-0.099em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle33 {
    letter-spacing:-0.091em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle34 {
    letter-spacing:-0.05em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle35 {
    letter-spacing:-0.112em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle36 {
    letter-spacing:-0.104em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle37 {
    letter-spacing:-0.062em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle38 {
    letter-spacing:-0.114em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle39 {
    letter-spacing:-0.121em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle40 {
    letter-spacing:-0.116em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle41 {
    letter-spacing:-0.149em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle42 {
    letter-spacing:-0.048em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle43 {
    letter-spacing:-0.04em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle44 {
    letter-spacing:-0.037em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle45 {
    letter-spacing:-0.108em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle46 {
    letter-spacing:-0.033em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle47 {
    letter-spacing:-0.136em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle48 {
    letter-spacing:-0.09em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle49 {
    letter-spacing:-0.137em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle50 {
    letter-spacing:-0.081em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle51 {
    letter-spacing:-0.155em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle52 {
    letter-spacing:-0.107em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle53 {
    letter-spacing:-0.103em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle54 {
    letter-spacing:-0.113em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle55 {
    letter-spacing:-0.111em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle56 {
    letter-spacing:-0.092em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle57 {
    letter-spacing:-0.127em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle58 {
    letter-spacing:-0.122em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle59 {
    letter-spacing:-0.126em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle60 {
    letter-spacing:-0.123em;
  }
  #g-calidad-de-la-gestion-large .g-cstyle61 {
    letter-spacing:-0.125em;
  }
  #g-calidad-de-la-gestion-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-de-la-gestion-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:12px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle0 {
    font-weight:800;
    line-height:36px;
    height:36px;
    letter-spacing:0em;
    font-size:30px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle1 {
    line-height:24px;
    height:24px;
    letter-spacing:-0.019em;
    font-size:20px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle2 {
    font-weight:800;
    line-height:24px;
    height:24px;
    letter-spacing:-0.019em;
    font-size:20px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle3 {
    font-weight:800;
    height:12px;
    letter-spacing:-0.019em;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle4 {
    height:12px;
    letter-spacing:-0.019em;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle5 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:13px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle6 {
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle7 {
    font-weight:800;
    height:12px;
    letter-spacing:0em;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle8 {
    font-weight:800;
    line-height:20px;
    height:20px;
    letter-spacing:0em;
    font-size:17px;
    color:rgb(188,190,192);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle9 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle10 {
    line-height:13px;
    height:13px;
    font-size:11px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle11 {
    line-height:13px;
    height:13px;
    letter-spacing:0em;
    font-size:11px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle12 {
    height:12px;
    letter-spacing:0em;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle13 {
    line-height:13px;
    height:13px;
    letter-spacing:-0.03em;
    font-size:11px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle14 {
    font-weight:800;
    line-height:20px;
    height:20px;
    letter-spacing:0em;
    font-size:17px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle15 {
    font-weight:800;
    line-height:20px;
    height:20px;
    letter-spacing:0em;
    font-size:17px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle16 {
    line-height:13px;
    height:13px;
    letter-spacing:-0.03em;
    font-size:11px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle17 {
    height:12px;
    letter-spacing:-0.019em;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle18 {
    font-weight:800;
    height:12px;
    letter-spacing:-0.019em;
    color:rgb(0,180,178);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle19 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle20 {
    font-weight:800;
    line-height:8px;
    height:8px;
    letter-spacing:-0.019em;
    font-size:7px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle21 {
    font-weight:800;
    line-height:8px;
    height:8px;
    letter-spacing:-0.036em;
    font-size:7px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle22 {
    font-weight:800;
    line-height:8px;
    height:8px;
    letter-spacing:-0.041em;
    font-size:7px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle23 {
    line-height:8px;
    height:8px;
    letter-spacing:-0.019em;
    font-size:7px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle24 {
    line-height:10px;
    height:10px;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle25 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle26 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle27 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.096em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle28 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle29 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle30 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle31 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.1em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle32 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.092em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle33 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.101em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle34 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.076em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle35 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.09em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle36 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.099em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle37 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.124em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle38 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle39 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.085em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle40 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.098em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle41 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.103em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle42 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.102em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle43 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.089em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle44 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.079em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle45 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.08em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle46 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.107em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle47 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.097em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle48 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.091em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle49 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.108em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle50 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.116em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle51 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.104em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle52 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.117em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle53 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.119em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle54 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.121em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle55 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.106em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle56 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.118em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle57 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.111em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-pstyle58 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.113em;
    font-size:9px;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle2 {
    letter-spacing:-0.03em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle3 {
    letter-spacing:-0.029em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle4 {
    letter-spacing:-0.019em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle5 {
    letter-spacing:-0.053em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle6 {
    letter-spacing:-0.035em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle7 {
    letter-spacing:-0.032em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle8 {
    letter-spacing:-0.043em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle9 {
    letter-spacing:-0.034em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle10 {
    letter-spacing:-0.036em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle11 {
    letter-spacing:-0.041em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle12 {
    letter-spacing:-0.086em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle13 {
    letter-spacing:-0.11em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle14 {
    letter-spacing:-0.05em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle15 {
    letter-spacing:-0.116em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle16 {
    letter-spacing:-0.039em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle17 {
    letter-spacing:-0.047em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle18 {
    letter-spacing:-0.048em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle19 {
    letter-spacing:-0.033em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle20 {
    letter-spacing:-0.044em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle21 {
    letter-spacing:-0.045em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle22 {
    letter-spacing:-0.101em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle23 {
    letter-spacing:-0.109em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle24 {
    letter-spacing:-0.049em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle25 {
    letter-spacing:-0.042em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle26 {
    letter-spacing:-0.098em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle27 {
    letter-spacing:-0.076em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle28 {
    letter-spacing:-0.133em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle29 {
    letter-spacing:-0.087em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle30 {
    letter-spacing:-0.105em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle31 {
    letter-spacing:-0.095em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle32 {
    letter-spacing:-0.117em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle33 {
    letter-spacing:-0.13em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle34 {
    letter-spacing:-0.135em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle35 {
    letter-spacing:-0.038em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle36 {
    letter-spacing:-0.099em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle37 {
    letter-spacing:-0.091em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle38 {
    letter-spacing:-0.112em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle39 {
    letter-spacing:-0.104em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle40 {
    letter-spacing:-0.062em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle41 {
    letter-spacing:-0.114em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle42 {
    letter-spacing:-0.121em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle43 {
    letter-spacing:-0.149em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle44 {
    letter-spacing:-0.04em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle45 {
    letter-spacing:-0.037em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle46 {
    letter-spacing:-0.108em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle47 {
    letter-spacing:-0.136em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle48 {
    letter-spacing:-0.09em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle49 {
    letter-spacing:-0.137em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle50 {
    letter-spacing:-0.081em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle51 {
    letter-spacing:-0.155em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle52 {
    letter-spacing:-0.107em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle53 {
    letter-spacing:-0.103em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle54 {
    letter-spacing:-0.113em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle55 {
    letter-spacing:-0.111em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle56 {
    letter-spacing:-0.092em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle57 {
    letter-spacing:-0.127em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle58 {
    letter-spacing:-0.122em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle59 {
    letter-spacing:-0.126em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle60 {
    letter-spacing:-0.123em;
  }
  #g-calidad-de-la-gestion-mobile .g-cstyle61 {
    letter-spacing:-0.125em;
  }

`

const html = props => `
<div id="g-calidad-de-la-gestion-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-calidad-de-la-gestion-large" class="g-artboard" style="width:940px; height:1361.77777777777px;" data-aspect-ratio="0.69" data-min-width="940">
<div style=""></div>
    <img id="g-calidad-de-la-gestion-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.4926%;margin-top:-38.2px;left:2.2016%;width:224px;">
      <p class="g-pstyle0">Ran<span class="g-cstyle0">k</span>in<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.4926%;margin-top:-38.2px;left:24.8303%;width:34px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.4926%;margin-top:-38.2px;left:26.2045%;width:637px;">
      <p class="g-pstyle2"><span class="g-cstyle0">d</span>e cal<span class="g-cstyle0">i</span>d<span class="g-cstyle0">a</span>d <span class="g-cstyle0">d</span>e <span class="g-cstyle0">l</span>a<span class="g-cstyle0"> g</span>es<span class="g-cstyle0">ti</span>ó<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.8119%;margin-top:-8.6px;left:35.1047%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle0">Í</span>n<span class="g-cstyle0">d</span>i<span class="g-cstyle0">c</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.9559%;margin-top:-10.6px;left:8.3505%;width:111px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle0">ers</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.9186%;margin-top:-9.1px;left:3.2197%;width:43px;">
      <p class="g-pstyle5">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.8445%;margin-top:-8.1px;left:45.3353%;width:38px;">
      <p class="g-pstyle6"><span class="g-cstyle0">R</span>K</p>
    </div>
    <div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.8445%;margin-top:-8.1px;left:47.1141%;width:25px;">
      <p class="g-pstyle6"> </p>
    </div>
    <div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.8445%;margin-top:-8.1px;left:51.9056%;width:89px;">
      <p class="g-pstyle7">Movim<span class="g-cstyle0">i</span>e<span class="g-cstyle0">n</span>to<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.7704%;margin-top:-7.1px;left:63.2982%;width:50px;">
      <p class="g-pstyle8"><span class="g-cstyle0">A</span>ños<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.7704%;margin-top:-7.1px;left:69.7143%;width:81px;">
      <p class="g-pstyle9">Estudiantes<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.7704%;margin-top:-7.1px;left:78.3408%;width:74px;">
      <p class="g-pstyle8">R<span class="g-cstyle0">e</span>tenci<span class="g-cstyle0">ó</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.8439%;margin-top:-7.1px;left:86.8444%;width:126px;">
      <p class="g-pstyle8"><span class="g-cstyle0">D</span>uraci<span class="g-cstyle0">ó</span>n<span class="g-cstyle0"> </span>prog<span class="g-cstyle0">r</span>a<span class="g-cstyle0">m</span>as<span class="g-cstyle0"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.9466%;margin-top:-9.1px;left:3.4047%;width:39px;">
      <p class="g-pstyle5"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.8726%;margin-top:-8.1px;left:33.5623%;width:85px;">
      <p class="g-pstyle3"><span class="g-cstyle0">p</span>onder<span class="g-cstyle0">a</span>d<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.8726%;margin-top:-8.1px;left:45.2222%;width:41px;">
      <p class="g-pstyle3"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.8726%;margin-top:-8.1px;left:53.1086%;width:65px;">
      <p class="g-pstyle7">&rsquo;<span class="g-cstyle0">2</span>0 a &rsquo;<span class="g-cstyle0">2</span><span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.7985%;margin-top:-7.1px;left:61.4989%;width:79px;">
      <p class="g-pstyle10">acreditado<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.7985%;margin-top:-7.1px;left:71.4108%;width:48px;">
      <p class="g-pstyle8">/<span class="g-cstyle0"> </span>JC<span class="g-cstyle1">E</span></p>
    </div>
    <div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.7985%;margin-top:-7.1px;left:77.9707%;width:81px;">
      <p class="g-pstyle8">d<span class="g-cstyle0">e</span> alu<span class="g-cstyle0">mn</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.7985%;margin-top:-7.1px;left:88.798%;width:89px;">
      <p class="g-pstyle8"><span class="g-cstyle0">e</span>n s<span class="g-cstyle0">e</span>m<span class="g-cstyle0">e</span>st<span class="g-cstyle0">r</span>e<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6797%;margin-top:-7.1px;left:87.4099%;width:54px;">
      <p class="g-pstyle11">Forma<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai0-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6797%;margin-top:-7.1px;left:94.2576%;width:42px;">
      <p class="g-pstyle11">Re<span class="g-cstyle0">a</span><span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai0-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.8266%;margin-top:-7.1px;left:79.3383%;width:53px;">
      <p class="g-pstyle8">2&deg; añ<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8044%;margin-top:-14.6px;left:56.8411%;width:31px;">
      <p class="g-pstyle12">&bull;</p>
    </div>
    <div id="g-ai0-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.7652%;margin-top:-9.1px;left:8.3505%;width:101px;">
      <p class="g-pstyle13"><span class="g-cstyle2">P</span>UC <span class="g-cstyle2">de </span>C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8019%;margin-top:-9.6px;left:61.8588%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8019%;margin-top:-9.6px;left:87.4612%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,37<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8019%;margin-top:-9.6px;left:93.62%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8753%;margin-top:-9.6px;left:35.1868%;width:59px;">
      <p class="g-pstyle16">9<span class="g-cstyle2">1</span>,<span class="g-cstyle2">4</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8753%;margin-top:-9.6px;left:45.9008%;width:31px;">
      <p class="g-pstyle14"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8753%;margin-top:-9.6px;left:54.9903%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">=</span> </p>
    </div>
    <div id="g-ai0-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8753%;margin-top:-9.6px;left:70.9481%;width:65px;">
      <p class="g-pstyle15"> 16<span class="g-cstyle6">,</span>0<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.8386%;margin-top:-9.1px;left:78.7522%;width:63px;">
      <p class="g-pstyle17">8<span class="g-cstyle7">3</span><span class="g-cstyle8">,</span>72%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.838%;margin-top:-8.1px;left:3.8984%;width:31px;">
      <p class="g-pstyle18"><span class="g-cstyle9">1</span> </p>
    </div>
    <div id="g-ai0-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.1996%;margin-top:-14.6px;left:56.8411%;width:31px;">
      <p class="g-pstyle12">&bull;</p>
    </div>
    <div id="g-ai0-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.087%;margin-top:-9.1px;left:8.3505%;width:87px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e C</span>hi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.1237%;margin-top:-9.6px;left:61.8588%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.1971%;margin-top:-9.6px;left:87.4509%;width:63px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle4">0</span><span class="g-cstyle11">,</span>01<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.1971%;margin-top:-9.6px;left:93.651%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,<span class="g-cstyle4">1</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2706%;margin-top:-9.6px;left:35.1457%;width:61px;">
      <p class="g-pstyle16">8<span class="g-cstyle2">5</span>,<span class="g-cstyle2">4</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2706%;margin-top:-9.6px;left:45.8699%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai0-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2706%;margin-top:-9.6px;left:54.9903%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">=</span> </p>
    </div>
    <div id="g-ai0-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2706%;margin-top:-9.6px;left:71.092%;width:63px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle13">7</span><span class="g-cstyle14">,</span>78 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2338%;margin-top:-9.1px;left:78.742%;width:61px;">
      <p class="g-pstyle21">82,12%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.1598%;margin-top:-8.1px;left:3.8675%;width:32px;">
      <p class="g-pstyle18"><span class="g-cstyle9">2</span> </p>
    </div>
    <div id="g-ai0-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4822%;margin-top:-9.1px;left:8.3505%;width:159px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle2">S</span>a<span class="g-cstyle2">n</span>t<span class="g-cstyle2">ia</span>go <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5189%;margin-top:-9.6px;left:61.8588%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5189%;margin-top:-9.6px;left:87.4921%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,<span class="g-cstyle2">1</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5189%;margin-top:-9.6px;left:93.5997%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>3 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5924%;margin-top:-9.6px;left:35.1457%;width:60px;">
      <p class="g-pstyle16">8<span class="g-cstyle15">4</span>,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5924%;margin-top:-9.6px;left:45.8596%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">8</span> </p>
    </div>
    <div id="g-ai0-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5924%;margin-top:-9.6px;left:55.0622%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.5924%;margin-top:-9.6px;left:70.9789%;width:66px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>27 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.6291%;margin-top:-9.1px;left:78.7625%;width:62px;">
      <p class="g-pstyle22">71<span class="g-cstyle17">,</span>05%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.555%;margin-top:-8.1px;left:3.8778%;width:33px;">
      <p class="g-pstyle18"><span class="g-cstyle9">3</span> </p>
    </div>
    <div id="g-ai0-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:17.5949%;margin-top:-14.6px;left:57.3563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.8774%;margin-top:-9.1px;left:8.3505%;width:119px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> De</span>s<span class="g-cstyle3">a</span>r<span class="g-cstyle18">r</span>o<span class="g-cstyle3">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9142%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9142%;margin-top:-9.6px;left:87.3995%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9142%;margin-top:-9.6px;left:93.5585%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9876%;margin-top:-9.6px;left:35.2382%;width:58px;">
      <p class="g-pstyle16">8<span class="g-cstyle15">4</span><span class="g-cstyle19">,</span>7<span class="g-cstyle2">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9876%;margin-top:-9.6px;left:45.8596%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">9</span> </p>
    </div>
    <div id="g-ai0-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9876%;margin-top:-9.6px;left:55.0622%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9876%;margin-top:-9.6px;left:70.9789%;width:65px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle15">4</span><span class="g-cstyle2">,</span>29<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.0243%;margin-top:-9.1px;left:78.7522%;width:62px;">
      <p class="g-pstyle17">7<span class="g-cstyle7">8</span><span class="g-cstyle8">,</span>78%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9503%;margin-top:-8.1px;left:3.8366%;width:33px;">
      <p class="g-pstyle18"><span class="g-cstyle9">4</span> </p>
    </div>
    <div id="g-ai0-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:18.9167%;margin-top:-14.6px;left:57.3562%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.2727%;margin-top:-9.1px;left:8.3505%;width:127px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">on</span>cepc<span class="g-cstyle2">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3094%;margin-top:-9.6px;left:61.8588%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3094%;margin-top:-9.6px;left:87.4612%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,57 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3094%;margin-top:-9.6px;left:93.5893%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span><span class="g-cstyle20">,</span>4<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3828%;margin-top:-9.6px;left:35.2279%;width:60px;">
      <p class="g-pstyle16">8<span class="g-cstyle21">3</span>,3<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3828%;margin-top:-9.6px;left:45.8802%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai0-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3828%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3828%;margin-top:-9.6px;left:70.9686%;width:65px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle4">9</span>,<span class="g-cstyle2">4</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3461%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle24">76,56%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3455%;margin-top:-8.1px;left:3.8778%;width:32px;">
      <p class="g-pstyle18"><span class="g-cstyle9">5</span> </p>
    </div>
    <div id="g-ai0-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:20.2385%;margin-top:-14.6px;left:57.399%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.5945%;margin-top:-9.1px;left:8.3505%;width:124px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span><span class="g-cstyle6">F</span><span class="g-cstyle18">r</span><span class="g-cstyle2">o</span>nt<span class="g-cstyle2">e</span>r<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6312%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7046%;margin-top:-9.6px;left:87.3995%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle20">,</span>4<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7046%;margin-top:-9.6px;left:93.6716%;width:62px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle20">,</span><span class="g-cstyle3">4</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7781%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7781%;margin-top:-9.6px;left:35.197%;width:59px;">
      <p class="g-pstyle16">7<span class="g-cstyle21">8</span><span class="g-cstyle22">,</span>98<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7781%;margin-top:-9.6px;left:45.8391%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai0-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7781%;margin-top:-9.6px;left:71.0201%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">3</span><span class="g-cstyle2">,</span>53 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.7413%;margin-top:-9.1px;left:78.8241%;width:63px;">
      <p class="g-pstyle26">7<span class="g-cstyle23">7</span><span class="g-cstyle24">,</span>97%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6673%;margin-top:-8.1px;left:3.8572%;width:33px;">
      <p class="g-pstyle18"><span class="g-cstyle9">6</span> </p>
    </div>
    <div id="g-ai0-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:21.7806%;margin-top:-14.6px;left:57.4096%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.9897%;margin-top:-9.1px;left:8.3505%;width:120px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">d</span>o<span class="g-cstyle2">l</span>fo<span class="g-cstyle2"> </span>Ib<span class="g-cstyle2">áñ</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0264%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:87.4098%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,2<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:93.5893%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle22">,</span>92<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:35.269%;width:57px;">
      <p class="g-pstyle27"><span class="g-cstyle3">7</span><span class="g-cstyle21">8</span>,5<span class="g-cstyle3">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:45.4689%;width:40px;">
      <p class="g-pstyle20">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:55.093%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0999%;margin-top:-9.6px;left:71.0201%;width:64px;">
      <p class="g-pstyle15"> 21<span class="g-cstyle19">,</span>7<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.1366%;margin-top:-9.1px;left:78.7317%;width:62px;">
      <p class="g-pstyle21">8<span class="g-cstyle25">3</span>,81%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0625%;margin-top:-8.1px;left:3.8881%;width:32px;">
      <p class="g-pstyle18"><span class="g-cstyle9">7</span> </p>
    </div>
    <div id="g-ai0-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:22.9555%;margin-top:-14.6px;left:57.3769%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.385%;margin-top:-9.1px;left:8.3505%;width:130px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Aus<span class="g-cstyle2">t</span>r<span class="g-cstyle2">al</span> <span class="g-cstyle2">de</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4217%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4217%;margin-top:-9.6px;left:87.4921%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,<span class="g-cstyle2">1</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4217%;margin-top:-9.6px;left:93.579%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4951%;margin-top:-9.6px;left:35.2587%;width:58px;">
      <p class="g-pstyle16">7<span class="g-cstyle13">7</span><span class="g-cstyle15">,</span><span class="g-cstyle2">0</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4951%;margin-top:-9.6px;left:45.8905%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4951%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4951%;margin-top:-9.6px;left:71.0098%;width:64px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle21">8</span><span class="g-cstyle14">,</span><span class="g-cstyle19">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.5318%;margin-top:-9.1px;left:78.7728%;width:62px;">
      <p class="g-pstyle28">7<span class="g-cstyle26">8</span>,13%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4578%;margin-top:-8.1px;left:3.8572%;width:32px;">
      <p class="g-pstyle18"><span class="g-cstyle9">8</span> </p>
    </div>
    <div id="g-ai0-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:24.2773%;margin-top:-14.6px;left:57.4095%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.7802%;margin-top:-9.1px;left:8.3505%;width:89px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle27">T</span><span class="g-cstyle2">a</span>l<span class="g-cstyle2">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8169%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8169%;margin-top:-9.6px;left:87.3892%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,50 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8169%;margin-top:-9.6px;left:93.5585%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>9 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8903%;margin-top:-9.6px;left:35.197%;width:60px;">
      <p class="g-pstyle16">76,2<span class="g-cstyle2">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8903%;margin-top:-9.6px;left:45.8596%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8903%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8903%;margin-top:-9.6px;left:70.9583%;width:65px;">
      <p class="g-pstyle15"> 21<span class="g-cstyle6">,</span>0<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.8536%;margin-top:-9.1px;left:78.742%;width:63px;">
      <p class="g-pstyle29">7<span class="g-cstyle28">9</span>,85%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.853%;margin-top:-8.1px;left:3.8572%;width:33px;">
      <p class="g-pstyle18"><span class="g-cstyle9">9</span> </p>
    </div>
    <div id="g-ai0-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:25.746%;margin-top:-14.6px;left:57.4095%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.102%;margin-top:-9.1px;left:8.3505%;width:115px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e l</span>os<span class="g-cstyle3"> A</span>nd<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.1387%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2121%;margin-top:-9.6px;left:87.4715%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,<span class="g-cstyle4">1</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2121%;margin-top:-9.6px;left:93.579%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,2<span class="g-cstyle2">6 </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2856%;margin-top:-9.6px;left:35.2485%;width:60px;">
      <p class="g-pstyle16">7<span class="g-cstyle2">5</span><span class="g-cstyle6">,</span>63<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2856%;margin-top:-9.6px;left:45.8802%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai0-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2856%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2856%;margin-top:-9.6px;left:71.0098%;width:64px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle21">8</span><span class="g-cstyle14">,</span><span class="g-cstyle19">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2489%;margin-top:-9.1px;left:78.6494%;width:62px;">
      <p class="g-pstyle30">8<span class="g-cstyle29">4</span><span class="g-cstyle30">,</span>90%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.1748%;margin-top:-8.1px;left:3.5076%;width:38px;">
      <p class="g-pstyle31">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:27.2146%;margin-top:-14.6px;left:57.4092%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.4972%;margin-top:-9.1px;left:8.3505%;width:143px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle18">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el No<span class="g-cstyle2">r</span>te<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.5339%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:87.3892%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,50 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:93.6304%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle31">5</span><span class="g-cstyle20">,</span>4<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:70.9892%;width:64px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>12 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:35.2485%;width:57px;">
      <p class="g-pstyle16"><span class="g-cstyle19">7</span><span class="g-cstyle6">4</span>,<span class="g-cstyle2">2</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6074%;margin-top:-9.6px;left:45.4689%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6441%;margin-top:-9.1px;left:78.7934%;width:60px;">
      <p class="g-pstyle32"><span class="g-cstyle32">7</span><span class="g-cstyle33">4</span>,11%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.57%;margin-top:-8.1px;left:3.5591%;width:36px;">
      <p class="g-pstyle31">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:28.463%;margin-top:-14.6px;left:57.4094%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.8925%;margin-top:-9.1px;left:8.3505%;width:132px;">
      <p class="g-pstyle19">P<span class="g-cstyle3">UC </span>de <span class="g-cstyle34">V</span>al<span class="g-cstyle3">p</span>a<span class="g-cstyle3">r</span>aís<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9292%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9292%;margin-top:-9.6px;left:87.3789%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9292%;margin-top:-9.6px;left:93.6203%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.0026%;margin-top:-9.6px;left:35.2382%;width:58px;">
      <p class="g-pstyle16"><span class="g-cstyle19">7</span><span class="g-cstyle6">4</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.0026%;margin-top:-9.6px;left:45.5306%;width:37px;">
      <p class="g-pstyle20">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.0026%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.0026%;margin-top:-9.6px;left:71.0818%;width:65px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle13">7</span>,<span class="g-cstyle2">5</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.0393%;margin-top:-9.1px;left:78.742%;width:61px;">
      <p class="g-pstyle33"><span class="g-cstyle35">7</span><span class="g-cstyle36">4</span>,18%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9653%;margin-top:-8.1px;left:3.5282%;width:38px;">
      <p class="g-pstyle31">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:29.8583%;margin-top:-14.6px;left:57.4195%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.2877%;margin-top:-9.1px;left:8.3505%;width:158px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">dv</span>en<span class="g-cstyle2">ti</span>sta <span class="g-cstyle2">de</span> C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3244%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3244%;margin-top:-9.6px;left:87.8108%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span><span class="g-cstyle34">7</span>4<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3244%;margin-top:-9.6px;left:93.6921%;width:62px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>11<span class="g-cstyle11">,</span><span class="g-cstyle34">7</span><span class="g-cstyle3">4</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3978%;margin-top:-9.6px;left:35.2485%;width:59px;">
      <p class="g-pstyle16">7<span class="g-cstyle21">3</span><span class="g-cstyle6">,</span><span class="g-cstyle2">0</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3978%;margin-top:-9.6px;left:46.2915%;width:26px;">
      <p class="g-pstyle14"> </p>
    </div>
    <div id="g-ai0-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3978%;margin-top:-9.6px;left:55.4632%;width:26px;">
      <p class="g-pstyle14"> </p>
    </div>
    <div id="g-ai0-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3978%;margin-top:-9.6px;left:71.0303%;width:63px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle15">4</span><span class="g-cstyle2">,</span>13<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3611%;margin-top:-9.1px;left:78.7522%;width:63px;">
      <p class="g-pstyle17">7<span class="g-cstyle38">9</span>,<span class="g-cstyle26">8</span>7%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.3605%;margin-top:-8.1px;left:3.5385%;width:38px;">
      <p class="g-pstyle31">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.6095%;margin-top:-9.1px;left:8.3505%;width:146px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle18">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el <span class="g-cstyle2">Ma</span>ule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.6462%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7196%;margin-top:-9.6px;left:87.7902%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span>7<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7196%;margin-top:-9.6px;left:93.6304%;width:63px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2,</span>18 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7931%;margin-top:-9.6px;left:35.197%;width:59px;">
      <p class="g-pstyle16">7<span class="g-cstyle2">2</span><span class="g-cstyle6">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7931%;margin-top:-9.6px;left:45.5101%;width:40px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7931%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7931%;margin-top:-9.6px;left:70.9892%;width:66px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle14">,</span>72 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.7563%;margin-top:-9.1px;left:78.7214%;width:63px;">
      <p class="g-pstyle34">7<span class="g-cstyle39">9</span><span class="g-cstyle8">,</span>66%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.6823%;margin-top:-8.1px;left:3.4974%;width:38px;">
      <p class="g-pstyle31">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:32.6487%;margin-top:-14.6px;left:57.4096%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0047%;margin-top:-9.1px;left:8.3505%;width:154px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> C</span><span class="g-cstyle18">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>ica<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle40">T</span>e<span class="g-cstyle3">mu</span>co<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0414%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:87.8005%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span>79 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:93.6099%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,5<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:35.2279%;width:60px;">
      <p class="g-pstyle16">7<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:45.4689%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:55.093%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai0-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1149%;margin-top:-9.6px;left:71.0303%;width:63px;">
      <p class="g-pstyle15"> 21<span class="g-cstyle2">,</span>1<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.1516%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle35">76,85%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0776%;margin-top:-8.1px;left:3.5385%;width:38px;">
      <p class="g-pstyle31">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:34.044%;margin-top:-14.6px;left:57.377%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4%;margin-top:-9.1px;left:8.3505%;width:206px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle18">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> R<span class="g-cstyle2">a</span>úl S<span class="g-cstyle2">i</span>l<span class="g-cstyle2">va</span> <span class="g-cstyle2">H</span>e<span class="g-cstyle2">n</span>r<span class="g-cstyle2">í</span>q<span class="g-cstyle2">u</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4367%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4367%;margin-top:-9.6px;left:87.7388%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,5<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4367%;margin-top:-9.6px;left:93.5276%;width:65px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle4">0</span><span class="g-cstyle6">,</span>88<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.5101%;margin-top:-9.6px;left:55.0622%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai0-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.5101%;margin-top:-9.6px;left:70.9789%;width:65px;">
      <p class="g-pstyle15"> 22<span class="g-cstyle2">,</span>4<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.5101%;margin-top:-9.6px;left:35.1662%;width:60px;">
      <p class="g-pstyle16">6<span class="g-cstyle4">9</span>,88<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.5101%;margin-top:-9.6px;left:45.4895%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.5468%;margin-top:-9.1px;left:78.7625%;width:63px;">
      <p class="g-pstyle22">7<span class="g-cstyle41">7</span>,49%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4728%;margin-top:-8.1px;left:3.5179%;width:38px;">
      <p class="g-pstyle31">16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:35.3658%;margin-top:-14.6px;left:57.3769%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.7952%;margin-top:-9.1px;left:8.3505%;width:117px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e L<span class="g-cstyle2">o</span>s<span class="g-cstyle2"> </span>L<span class="g-cstyle2">a</span>go<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.8319%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.8319%;margin-top:-9.6px;left:87.8417%;width:56px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span><span class="g-cstyle37">9</span><span class="g-cstyle20">,</span><span class="g-cstyle3">4</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.8319%;margin-top:-9.6px;left:93.7024%;width:62px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle11">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9053%;margin-top:-9.6px;left:35.1868%;width:60px;">
      <p class="g-pstyle16">6<span class="g-cstyle4">9</span><span class="g-cstyle2">,</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9053%;margin-top:-9.6px;left:45.5101%;width:40px;">
      <p class="g-pstyle15">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9053%;margin-top:-9.6px;left:54.7229%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle42">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9053%;margin-top:-9.6px;left:70.9583%;width:66px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>58<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.8686%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle35">76,58%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.868%;margin-top:-8.1px;left:3.5488%;width:37px;">
      <p class="g-pstyle31">17<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:36.8344%;margin-top:-14.6px;left:57.356%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.117%;margin-top:-9.1px;left:8.3505%;width:234px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e P<span class="g-cstyle2">l</span>a<span class="g-cstyle2">y</span>a<span class="g-cstyle2"> </span>An<span class="g-cstyle2">c</span>h<span class="g-cstyle2">a</span> d<span class="g-cstyle2">e</span> C<span class="g-cstyle2">s</span>. <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> la</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.1537%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.2272%;margin-top:-9.6px;left:87.7902%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle20">,</span>43 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.2272%;margin-top:-9.6px;left:93.5893%;width:65px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle43">3</span><span class="g-cstyle3">,2</span>8 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.3006%;margin-top:-9.6px;left:35.2073%;width:60px;">
      <p class="g-pstyle16">6<span class="g-cstyle4">9</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.3006%;margin-top:-9.6px;left:45.4998%;width:39px;">
      <p class="g-pstyle20">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.3006%;margin-top:-9.6px;left:55.0622%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai0-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.3006%;margin-top:-9.6px;left:71.0201%;width:63px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle21">8</span>,<span class="g-cstyle2">18</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.2638%;margin-top:-9.1px;left:78.7831%;width:60px;">
      <p class="g-pstyle36">71,14%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.1898%;margin-top:-8.1px;left:3.5179%;width:38px;">
      <p class="g-pstyle31">18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:38.0828%;margin-top:-14.6px;left:57.3562%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5122%;margin-top:-9.1px;left:8.3505%;width:209px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span><span class="g-cstyle40">T</span>é<span class="g-cstyle3">c</span>n<span class="g-cstyle3">i</span>ca F<span class="g-cstyle3">e</span>de<span class="g-cstyle3">r</span>i<span class="g-cstyle3">c</span>o<span class="g-cstyle3"> S</span>an<span class="g-cstyle3">t</span>a<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">rí</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.549%;margin-top:-9.6px;left:61.8279%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai0-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:87.4921%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span>77 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:93.5482%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle44">6</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:35.197%;width:58px;">
      <p class="g-pstyle16">6<span class="g-cstyle4">9</span>,<span class="g-cstyle2">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:45.4895%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6224%;margin-top:-9.6px;left:70.9378%;width:67px;">
      <p class="g-pstyle15"> 3<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>24 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.6591%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle35"><span class="g-cstyle40">7</span><span class="g-cstyle45">4</span>,22%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5851%;margin-top:-8.1px;left:3.5179%;width:38px;">
      <p class="g-pstyle31">19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:39.478%;margin-top:-14.6px;left:57.3989%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9075%;margin-top:-9.1px;left:8.3505%;width:129px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e A<span class="g-cstyle2">n</span>t<span class="g-cstyle46">o</span>f<span class="g-cstyle2">a</span>g<span class="g-cstyle2">a</span>sta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9442%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9442%;margin-top:-9.6px;left:87.3789%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9442%;margin-top:-9.6px;left:93.6099%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,32 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0176%;margin-top:-9.6px;left:35.2382%;width:59px;">
      <p class="g-pstyle16">6<span class="g-cstyle21">8</span><span class="g-cstyle19">,</span>77<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0176%;margin-top:-9.6px;left:45.4895%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0176%;margin-top:-9.6px;left:54.7229%;width:40px;">
      <p class="g-pstyle15">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0176%;margin-top:-9.6px;left:71.0098%;width:65px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle4">9</span><span class="g-cstyle15">,</span>63<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0543%;margin-top:-9.1px;left:78.814%;width:63px;">
      <p class="g-pstyle37">7<span class="g-cstyle47">7</span><span class="g-cstyle48">,</span>93%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9803%;margin-top:-8.1px;left:3.4768%;width:40px;">
      <p class="g-pstyle31">20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:40.7998%;margin-top:-14.6px;left:57.4095%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3027%;margin-top:-9.1px;left:8.3505%;width:77px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">y</span>o<span class="g-cstyle3">r</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3394%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3394%;margin-top:-9.6px;left:87.8211%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3394%;margin-top:-9.6px;left:93.6203%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.4129%;margin-top:-9.6px;left:35.1457%;width:61px;">
      <p class="g-pstyle16">6<span class="g-cstyle21">8</span><span class="g-cstyle2">,</span>49<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.4129%;margin-top:-9.6px;left:45.5101%;width:39px;">
      <p class="g-pstyle20">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.4129%;margin-top:-9.6px;left:54.7332%;width:39px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.4129%;margin-top:-9.6px;left:70.9378%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">3</span><span class="g-cstyle2">,</span>4<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3761%;margin-top:-9.1px;left:78.8036%;width:63px;">
      <p class="g-pstyle38">7<span class="g-cstyle49">7</span><span class="g-cstyle24">,</span><span class="g-cstyle50">0</span>7%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.3755%;margin-top:-8.1px;left:3.5282%;width:38px;">
      <p class="g-pstyle31">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:42.2685%;margin-top:-14.6px;left:57.4094%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6245%;margin-top:-9.1px;left:8.3505%;width:124px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>Mag<span class="g-cstyle3">a</span>l<span class="g-cstyle3">l</span>ane<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6612%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7347%;margin-top:-9.6px;left:87.7491%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle22">,</span><span class="g-cstyle2">9</span>9 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7347%;margin-top:-9.6px;left:93.5893%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle20">,</span>4<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8081%;margin-top:-9.6px;left:35.1662%;width:60px;">
      <p class="g-pstyle27"><span class="g-cstyle3">6</span><span class="g-cstyle21">8</span>,<span class="g-cstyle3">4</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8081%;margin-top:-9.6px;left:45.4586%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8081%;margin-top:-9.6px;left:55.0314%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8081%;margin-top:-9.6px;left:71.0303%;width:63px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> 1</span><span class="g-cstyle15">4</span>,<span class="g-cstyle3">5</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7713%;margin-top:-9.1px;left:78.742%;width:63px;">
      <p class="g-pstyle33">6<span class="g-cstyle51">7</span>,86%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6973%;margin-top:-8.1px;left:3.4974%;width:39px;">
      <p class="g-pstyle31">22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:43.5903%;margin-top:-14.6px;left:57.3563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.0197%;margin-top:-9.1px;left:8.3505%;width:118px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle34">V</span>a<span class="g-cstyle3">l</span>pa<span class="g-cstyle3">r</span>a<span class="g-cstyle3">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.0565%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:87.4304%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,23 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:93.651%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span><span class="g-cstyle11">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:35.197%;width:60px;">
      <p class="g-pstyle27"><span class="g-cstyle3">6</span><span class="g-cstyle21">8</span>,<span class="g-cstyle3">3</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:45.5203%;width:39px;">
      <p class="g-pstyle15"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:54.7332%;width:39px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1299%;margin-top:-9.6px;left:71.0406%;width:64px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle21">8</span><span class="g-cstyle14">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.1666%;margin-top:-9.1px;left:78.7214%;width:63px;">
      <p class="g-pstyle34">72<span class="g-cstyle38">,</span>98%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.0926%;margin-top:-8.1px;left:3.5076%;width:40px;">
      <p class="g-pstyle31">23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:45.0589%;margin-top:-14.6px;left:57.4093%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.415%;margin-top:-9.1px;left:8.3505%;width:205px;">
      <p class="g-pstyle13"><span class="g-cstyle2">U</span>C <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> </span>la<span class="g-cstyle2"> </span>S<span class="g-cstyle2">a</span>nt<span class="g-cstyle2">ís</span>im<span class="g-cstyle2">a</span> C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">c</span>ep<span class="g-cstyle2">ci</span>ón<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.4517%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.4517%;margin-top:-9.6px;left:87.7594%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,5<span class="g-cstyle2">4</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.4517%;margin-top:-9.6px;left:93.5997%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2<span class="g-cstyle5">,</span><span class="g-cstyle2">6</span>3 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5251%;margin-top:-9.6px;left:35.2279%;width:59px;">
      <p class="g-pstyle16">6<span class="g-cstyle13">7</span><span class="g-cstyle22">,</span>9<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5251%;margin-top:-9.6px;left:45.4483%;width:42px;">
      <p class="g-pstyle15">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5251%;margin-top:-9.6px;left:55.0417%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle2">6</span> </p>
    </div>
    <div id="g-ai0-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5251%;margin-top:-9.6px;left:70.9686%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">3</span><span class="g-cstyle15">,</span>68 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.5618%;margin-top:-9.1px;left:78.7522%;width:63px;">
      <p class="g-pstyle17">76<span class="g-cstyle8">,</span>79%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.4878%;margin-top:-8.1px;left:3.4768%;width:40px;">
      <p class="g-pstyle31">24<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:46.4542%;margin-top:-14.6px;left:57.3563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8102%;margin-top:-9.1px;left:8.3505%;width:112px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> A</span>nd<span class="g-cstyle46">r</span><span class="g-cstyle3">é</span>s<span class="g-cstyle3"> </span>B<span class="g-cstyle3">e</span>l<span class="g-cstyle3">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8469%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8469%;margin-top:-9.6px;left:87.7799%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle20">,</span>42<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8469%;margin-top:-9.6px;left:93.5893%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">9</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9204%;margin-top:-9.6px;left:35.2587%;width:59px;">
      <p class="g-pstyle27"><span class="g-cstyle3">6</span><span class="g-cstyle13">7</span>,5<span class="g-cstyle3">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9204%;margin-top:-9.6px;left:45.4792%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9204%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.9204%;margin-top:-9.6px;left:70.9686%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">3</span><span class="g-cstyle15">,</span>66 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.8836%;margin-top:-9.1px;left:78.7522%;width:63px;">
      <p class="g-pstyle17">72<span class="g-cstyle52">,</span>95%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-297" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.883%;margin-top:-8.1px;left:3.5076%;width:39px;">
      <p class="g-pstyle31">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-298" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:47.776%;margin-top:-14.6px;left:57.3989%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-299" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.132%;margin-top:-9.1px;left:8.3505%;width:124px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> D</span>i<span class="g-cstyle3">e</span>go<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>r<span class="g-cstyle3">t</span>a<span class="g-cstyle3">l</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-300" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.1687%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-301" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2422%;margin-top:-9.6px;left:87.7594%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,5<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-302" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2422%;margin-top:-9.6px;left:93.6099%;width:64px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle11">,</span><span class="g-cstyle3">7</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-303" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3156%;margin-top:-9.6px;left:35.269%;width:57px;">
      <p class="g-pstyle16">6<span class="g-cstyle13">7</span>,4<span class="g-cstyle2">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-304" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3156%;margin-top:-9.6px;left:45.4381%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-305" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3156%;margin-top:-9.6px;left:54.7332%;width:39px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-306" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3156%;margin-top:-9.6px;left:70.9173%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle15">4</span><span class="g-cstyle6">,</span>64 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-307" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2788%;margin-top:-9.1px;left:78.7728%;width:63px;">
      <p class="g-pstyle28">76<span class="g-cstyle53">,</span>73%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-308" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2048%;margin-top:-8.1px;left:3.4871%;width:40px;">
      <p class="g-pstyle31">26<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-309" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:49.1712%;margin-top:-14.6px;left:57.4197%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-310" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.5272%;margin-top:-9.1px;left:8.3505%;width:122px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>n <span class="g-cstyle2">S</span>eb<span class="g-cstyle2">as</span>t<span class="g-cstyle2">i</span>á<span class="g-cstyle2">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-311" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.564%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-312" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:87.7285%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle5">,</span>6<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-313" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:93.6099%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-314" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:35.2073%;width:59px;">
      <p class="g-pstyle16">6<span class="g-cstyle13">7</span><span class="g-cstyle15">,</span><span class="g-cstyle2">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-315" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:45.4998%;width:39px;">
      <p class="g-pstyle20">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-316" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:54.435%;width:45px;">
      <p class="g-pstyle15">-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-317" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6374%;margin-top:-9.6px;left:70.9789%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle4">9</span>,8<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-318" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6741%;margin-top:-9.1px;left:78.7111%;width:61px;">
      <p class="g-pstyle39">8<span class="g-cstyle28">0</span><span class="g-cstyle54">,</span>61%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-319" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.6001%;margin-top:-8.1px;left:3.5179%;width:39px;">
      <p class="g-pstyle31">27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-320" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:50.5665%;margin-top:-14.6px;left:57.4092%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-321" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9225%;margin-top:-9.1px;left:8.3505%;width:102px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle11">-</span><span class="g-cstyle3">Bí</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-322" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9592%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-323" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9592%;margin-top:-9.6px;left:87.7697%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle22">,</span><span class="g-cstyle2">9</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-324" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9592%;margin-top:-9.6px;left:93.579%;width:65px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle43">3</span><span class="g-cstyle3">,2</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-325" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.0326%;margin-top:-9.6px;left:35.1765%;width:60px;">
      <p class="g-pstyle27"><span class="g-cstyle3">66</span>,58<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-326" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.0326%;margin-top:-9.6px;left:45.4381%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-327" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.0326%;margin-top:-9.6px;left:54.7229%;width:40px;">
      <p class="g-pstyle15">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-328" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.0326%;margin-top:-9.6px;left:70.9583%;width:67px;">
      <p class="g-pstyle15"> 25<span class="g-cstyle6">,</span><span class="g-cstyle2">0</span>9<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-329" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.0693%;margin-top:-9.1px;left:78.742%;width:63px;">
      <p class="g-pstyle40"><span class="g-cstyle55">7</span><span class="g-cstyle53">4</span><span class="g-cstyle27">,</span>78%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-330" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.9953%;margin-top:-8.1px;left:3.4871%;width:39px;">
      <p class="g-pstyle31">28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-331" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:51.8883%;margin-top:-14.6px;left:57.399%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-332" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3177%;margin-top:-9.1px;left:8.3505%;width:107px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Fi<span class="g-cstyle2">n</span>i<span class="g-cstyle2">s </span><span class="g-cstyle40">T</span>er<span class="g-cstyle2">ra</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-333" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3544%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-334" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3544%;margin-top:-9.6px;left:87.7594%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,5<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-335" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3544%;margin-top:-9.6px;left:93.651%;width:62px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">11</span><span class="g-cstyle5">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-336" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.4279%;margin-top:-9.6px;left:35.2279%;width:59px;">
      <p class="g-pstyle16">6<span class="g-cstyle2">5</span><span class="g-cstyle6">,</span>67<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-337" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.4279%;margin-top:-9.6px;left:45.4792%;width:41px;">
      <p class="g-pstyle20">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-338" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.4279%;margin-top:-9.6px;left:54.7229%;width:40px;">
      <p class="g-pstyle15">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-339" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.4279%;margin-top:-9.6px;left:70.9378%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle15">,</span>66 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-340" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3911%;margin-top:-9.1px;left:78.7728%;width:63px;">
      <p class="g-pstyle41">75<span class="g-cstyle56">,</span>52%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-341" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.3905%;margin-top:-8.1px;left:3.4871%;width:40px;">
      <p class="g-pstyle31">29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-342" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:53.357%;margin-top:-14.6px;left:57.389%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-343" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.6395%;margin-top:-9.1px;left:8.3505%;width:112px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle27">T</span>a<span class="g-cstyle3">r</span>apa<span class="g-cstyle3">c</span>á<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-344" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.6762%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-345" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.7497%;margin-top:-9.6px;left:87.4304%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,23 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-346" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.7497%;margin-top:-9.6px;left:93.6203%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle31">5</span>,25<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-347" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.8231%;margin-top:-9.6px;left:35.2279%;width:58px;">
      <p class="g-pstyle16">6<span class="g-cstyle21">3</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-348" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.8231%;margin-top:-9.6px;left:45.4895%;width:40px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-349" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.8231%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-350" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.8231%;margin-top:-9.6px;left:71.0303%;width:64px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">8</span><span class="g-cstyle14">,</span>71 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-351" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.7864%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle35">76,39%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-352" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.7123%;margin-top:-8.1px;left:3.4871%;width:40px;">
      <p class="g-pstyle31">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-353" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:54.6788%;margin-top:-14.6px;left:57.3988%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-354" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.0348%;margin-top:-9.1px;left:8.3505%;width:149px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Aut<span class="g-cstyle2">ó</span>n<span class="g-cstyle2">o</span>m<span class="g-cstyle2">a</span> d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-355" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.0715%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-356" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:87.8724%;width:56px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-357" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:93.5482%;width:65px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle11">,</span>08 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-358" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:35.1662%;width:60px;">
      <p class="g-pstyle16">6<span class="g-cstyle2">2</span>,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-359" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:45.4483%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-360" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-361" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1449%;margin-top:-9.6px;left:71.0098%;width:67px;">
      <p class="g-pstyle15"> 25<span class="g-cstyle2">,</span>33 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-362" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1816%;margin-top:-9.1px;left:78.7111%;width:61px;">
      <p class="g-pstyle42">81,24%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-363" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.1076%;margin-top:-8.1px;left:3.5385%;width:38px;">
      <p class="g-pstyle31">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-364" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:56.0006%;margin-top:-14.6px;left:57.4094%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-365" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.43%;margin-top:-9.1px;left:8.3505%;width:151px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Be<span class="g-cstyle2">r</span>n<span class="g-cstyle2">ardo</span> O<span class="g-cstyle2">&rsquo;</span>H<span class="g-cstyle2">i</span>ggin<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-366" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4667%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-367" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4667%;margin-top:-9.6px;left:87.8724%;width:56px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle11">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-368" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4667%;margin-top:-9.6px;left:93.5893%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-369" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5401%;margin-top:-9.6px;left:35.1868%;width:60px;">
      <p class="g-pstyle27"><span class="g-cstyle3">6</span>2<span class="g-cstyle6">,</span><span class="g-cstyle3">6</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-370" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5401%;margin-top:-9.6px;left:45.4586%;width:41px;">
      <p class="g-pstyle15"><span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-371" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5401%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-372" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5401%;margin-top:-9.6px;left:70.9686%;width:66px;">
      <p class="g-pstyle15"> 22<span class="g-cstyle2">,</span>29 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-373" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5768%;margin-top:-9.1px;left:78.7317%;width:63px;">
      <p class="g-pstyle24">76<span class="g-cstyle52">,</span>63%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-374" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5028%;margin-top:-8.1px;left:3.5076%;width:40px;">
      <p class="g-pstyle31">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-375" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:57.3957%;margin-top:-14.6px;left:57.4095%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-376" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.8252%;margin-top:-9.1px;left:8.3505%;width:116px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span>Se<span class="g-cstyle46">r</span>e<span class="g-cstyle2">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-377" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.8619%;margin-top:-9.6px;left:61.8485%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-378" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.8619%;margin-top:-9.6px;left:87.4818%;width:62px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span>,<span class="g-cstyle2">1</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-379" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.8619%;margin-top:-9.6px;left:93.651%;width:62px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle31">5</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-380" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9354%;margin-top:-9.6px;left:35.156%;width:60px;">
      <p class="g-pstyle16">6<span class="g-cstyle2">2</span>,<span class="g-cstyle2">4</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-381" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9354%;margin-top:-9.6px;left:45.4998%;width:41px;">
      <p class="g-pstyle15">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-382" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9354%;margin-top:-9.6px;left:55.0314%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-383" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9354%;margin-top:-9.6px;left:70.9583%;width:66px;">
      <p class="g-pstyle15"> 26<span class="g-cstyle2">,</span>4<span class="g-cstyle2">7</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-384" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.8986%;margin-top:-9.1px;left:78.6802%;width:63px;">
      <p class="g-pstyle43">66<span class="g-cstyle57">,</span>99%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-385" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.898%;margin-top:-8.1px;left:3.5179%;width:40px;">
      <p class="g-pstyle31">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-386" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:58.8645%;margin-top:-14.6px;left:57.3563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-387" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.147%;margin-top:-9.1px;left:8.3505%;width:132px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> A</span>l<span class="g-cstyle3">b</span>e<span class="g-cstyle3">r</span>to<span class="g-cstyle3"> </span>H<span class="g-cstyle3">u</span>r<span class="g-cstyle3">t</span>ad<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-388" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.1837%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-389" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.2572%;margin-top:-9.6px;left:87.7182%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle6">,</span>8<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-390" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.2572%;margin-top:-9.6px;left:93.6203%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">11</span><span class="g-cstyle6">,</span>84 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-391" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3306%;margin-top:-9.6px;left:35.2073%;width:58px;">
      <p class="g-pstyle16">6<span class="g-cstyle2">1</span>,<span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-392" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3306%;margin-top:-9.6px;left:45.4792%;width:41px;">
      <p class="g-pstyle15">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-393" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3306%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-394" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3306%;margin-top:-9.6px;left:71.0201%;width:65px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle13">7</span>,8<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-395" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.2939%;margin-top:-9.1px;left:78.7214%;width:63px;">
      <p class="g-pstyle44">6<span class="g-cstyle58">9</span>,52%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-396" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.2199%;margin-top:-8.1px;left:3.4768%;width:40px;">
      <p class="g-pstyle31">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-397" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:60.1863%;margin-top:-14.6px;left:57.4299%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-398" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5423%;margin-top:-9.1px;left:8.3505%;width:135px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2">s</span> Amé<span class="g-cstyle2">r</span>i<span class="g-cstyle2">ca</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-399" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.579%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-400" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:87.7388%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-401" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:93.7024%;width:61px;">
      <p class="g-pstyle20"><span class="g-cstyle3"> </span>11<span class="g-cstyle6">,</span>81<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-402" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:35.2485%;width:60px;">
      <p class="g-pstyle16"><span class="g-cstyle2">5</span><span class="g-cstyle4">9</span>,<span class="g-cstyle2">5</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-403" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:45.4895%;width:42px;">
      <p class="g-pstyle15">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-404" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-405" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6524%;margin-top:-9.6px;left:70.9686%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">3</span><span class="g-cstyle2">,</span>42 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-406" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6891%;margin-top:-9.1px;left:78.742%;width:62px;">
      <p class="g-pstyle40">61<span class="g-cstyle45">,</span>95%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-407" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6151%;margin-top:-8.1px;left:3.5179%;width:40px;">
      <p class="g-pstyle31">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-408" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:61.508%;margin-top:-14.6px;left:57.4093%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-409" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.9375%;margin-top:-9.1px;left:8.3505%;width:115px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>nt<span class="g-cstyle2">o</span> <span class="g-cstyle40">T</span>om<span class="g-cstyle2">ás</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-410" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.9742%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-411" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.9742%;margin-top:-9.6px;left:87.7594%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle22">,</span><span class="g-cstyle2">9</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-412" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.9742%;margin-top:-9.6px;left:93.6099%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle43">3</span><span class="g-cstyle5">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-413" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0476%;margin-top:-9.6px;left:35.197%;width:60px;">
      <p class="g-pstyle27">5<span class="g-cstyle4">9</span><span class="g-cstyle6">,</span><span class="g-cstyle3">0</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-414" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0476%;margin-top:-9.6px;left:45.4689%;width:40px;">
      <p class="g-pstyle20">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-415" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0476%;margin-top:-9.6px;left:55.0622%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai0-416" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0476%;margin-top:-9.6px;left:70.9173%;width:67px;">
      <p class="g-pstyle15"> 22<span class="g-cstyle2">,</span>4<span class="g-cstyle2">4 </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-417" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0843%;margin-top:-9.1px;left:78.7111%;width:63px;">
      <p class="g-pstyle42">6<span class="g-cstyle59">9</span>,22%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-418" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0103%;margin-top:-8.1px;left:3.4974%;width:40px;">
      <p class="g-pstyle31">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-419" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:62.9767%;margin-top:-14.6px;left:57.3665%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-420" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3327%;margin-top:-9.1px;left:8.3505%;width:225px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">M</span>et<span class="g-cstyle46">r</span><span class="g-cstyle2">op</span>o<span class="g-cstyle2">l</span>ita<span class="g-cstyle2">na</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">s</span>. d<span class="g-cstyle2">e</span> l<span class="g-cstyle2">a</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-421" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3694%;margin-top:-9.6px;left:61.8485%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai0-422" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3694%;margin-top:-9.6px;left:87.3584%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-423" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3694%;margin-top:-9.6px;left:93.6099%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle43">3</span><span class="g-cstyle5">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-424" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4429%;margin-top:-9.6px;left:35.156%;width:60px;">
      <p class="g-pstyle27">5<span class="g-cstyle21">8</span><span class="g-cstyle6">,</span><span class="g-cstyle3">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-425" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4429%;margin-top:-9.6px;left:45.4483%;width:42px;">
      <p class="g-pstyle15">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-426" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4429%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-427" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4429%;margin-top:-9.6px;left:71.0201%;width:64px;">
      <p class="g-pstyle15"> 1<span class="g-cstyle2">5</span>,2<span class="g-cstyle2">2</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-428" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4061%;margin-top:-9.1px;left:78.67%;width:62px;">
      <p class="g-pstyle45">6<span class="g-cstyle30">9</span><span class="g-cstyle60">,</span>60%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-429" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4056%;margin-top:-8.1px;left:3.5282%;width:39px;">
      <p class="g-pstyle31">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-430" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:64.3719%;margin-top:-14.6px;left:57.4093%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-431" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.6545%;margin-top:-9.1px;left:8.3505%;width:109px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle18">A</span>ta<span class="g-cstyle3">c</span>a<span class="g-cstyle3">m</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-432" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.6913%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-433" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7647%;margin-top:-9.6px;left:87.3995%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-434" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7647%;margin-top:-9.6px;left:93.5585%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle31">5</span><span class="g-cstyle11">,</span><span class="g-cstyle2">0</span>8 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-435" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.8381%;margin-top:-9.6px;left:35.269%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle2">5</span><span class="g-cstyle13">7</span><span class="g-cstyle22">,</span>99<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-436" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.8381%;margin-top:-9.6px;left:45.4072%;width:42px;">
      <p class="g-pstyle15"><span class="g-cstyle2">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-437" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.8381%;margin-top:-9.6px;left:55.0622%;width:33px;">
      <p class="g-pstyle14"><span class="g-cstyle3">2</span> </p>
    </div>
    <div id="g-ai0-438" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.8381%;margin-top:-9.6px;left:70.9378%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>4<span class="g-cstyle2">5</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-439" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.8014%;margin-top:-9.1px;left:78.67%;width:62px;">
      <p class="g-pstyle46">65<span class="g-cstyle61">,</span>04%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-440" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7274%;margin-top:-8.1px;left:3.4974%;width:40px;">
      <p class="g-pstyle31">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-441" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.4239475708028%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.4239475708028%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.4239475708028%;top:65.6938%;margin-top:-14.6px;left:57.3563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle23">&rsaquo;</p>
    </div>
    <div id="g-ai0-442" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0498%;margin-top:-9.1px;left:8.3505%;width:192px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span><span class="g-cstyle40">T</span>e<span class="g-cstyle3">c</span>n<span class="g-cstyle3">o</span>ló<span class="g-cstyle3">g</span>ic<span class="g-cstyle3">a </span>M<span class="g-cstyle3">et</span><span class="g-cstyle46">r</span>o<span class="g-cstyle3">po</span>li<span class="g-cstyle3">t</span>an<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-443" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0865%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-444" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:87.4098%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span><span class="g-cstyle4">0</span><span class="g-cstyle20">,</span>4<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-445" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:93.5687%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-446" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:35.3102%;width:58px;">
      <p class="g-pstyle16"><span class="g-cstyle2">5</span><span class="g-cstyle13">7</span><span class="g-cstyle19">,</span>79<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-447" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:45.4586%;width:42px;">
      <p class="g-pstyle15">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-448" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-449" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1599%;margin-top:-9.6px;left:70.9789%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle15">4</span><span class="g-cstyle2">,</span>5<span class="g-cstyle2">5</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-450" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1966%;margin-top:-9.1px;left:78.6597%;width:62px;">
      <p class="g-pstyle47">6<span class="g-cstyle59">8</span><span class="g-cstyle57">,</span>64%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-451" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1226%;margin-top:-8.1px;left:3.4974%;width:40px;">
      <p class="g-pstyle31">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-452" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:67.089%;margin-top:-14.6px;left:57.3989%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-453" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.445%;margin-top:-9.1px;left:8.3505%;width:132px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Ce<span class="g-cstyle2">nt</span>r<span class="g-cstyle2">a</span>l <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">il</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-454" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4817%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-455" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4817%;margin-top:-9.6px;left:87.7388%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle6">,</span>8<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-456" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4817%;margin-top:-9.6px;left:93.5997%;width:64px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,22<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-457" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5552%;margin-top:-9.6px;left:35.197%;width:60px;">
      <p class="g-pstyle16"><span class="g-cstyle2">5</span>6,<span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-458" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5552%;margin-top:-9.6px;left:45.4689%;width:42px;">
      <p class="g-pstyle15">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-459" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5552%;margin-top:-9.6px;left:54.7229%;width:40px;">
      <p class="g-pstyle15">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-460" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5552%;margin-top:-9.6px;left:70.9481%;width:67px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">8</span>,<span class="g-cstyle2">5</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-461" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5918%;margin-top:-9.1px;left:78.7111%;width:63px;">
      <p class="g-pstyle48">7<span class="g-cstyle55">3</span>,<span class="g-cstyle52">84</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-462" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5178%;margin-top:-8.1px;left:3.4459%;width:40px;">
      <p class="g-pstyle31">40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-463" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:68.3374%;margin-top:-14.6px;left:57.3992%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-464" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8402%;margin-top:-9.1px;left:8.3505%;width:103px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> A</span>r<span class="g-cstyle3">t</span>u<span class="g-cstyle18">r</span>o <span class="g-cstyle3">P</span>r<span class="g-cstyle18">a</span>t<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-465" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.877%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-466" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.877%;margin-top:-9.6px;left:87.7594%;width:58px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle6">,</span>85 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-467" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.877%;margin-top:-9.6px;left:93.5893%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,39 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-468" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9504%;margin-top:-9.6px;left:35.1765%;width:60px;">
      <p class="g-pstyle27">55<span class="g-cstyle6">,</span><span class="g-cstyle3">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-469" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9504%;margin-top:-9.6px;left:45.4689%;width:42px;">
      <p class="g-pstyle15">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-470" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9504%;margin-top:-9.6px;left:54.7537%;width:39px;">
      <p class="g-pstyle15">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-471" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9504%;margin-top:-9.6px;left:70.9995%;width:66px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle21">8</span><span class="g-cstyle14">,</span>72 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-472" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9136%;margin-top:-9.1px;left:78.67%;width:62px;">
      <p class="g-pstyle49">6<span class="g-cstyle60">8</span>,20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-473" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.9131%;margin-top:-8.1px;left:3.4974%;width:38px;">
      <p class="g-pstyle31">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-474" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:69.806%;margin-top:-14.6px;left:57.3989%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-475" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.162%;margin-top:-9.1px;left:8.3505%;width:241px;">
      <p class="g-pstyle13"><span class="g-cstyle10">U</span><span class="g-cstyle2">.</span> Ac<span class="g-cstyle2">ade</span>m<span class="g-cstyle2">ia</span> <span class="g-cstyle2">de</span> <span class="g-cstyle2">H</span>uma<span class="g-cstyle2">ni</span>smo<span class="g-cstyle2"> </span>Cri<span class="g-cstyle2">s</span>t<span class="g-cstyle2">ia</span>no<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-476" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1988%;margin-top:-9.6px;left:61.8073%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai0-477" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2722%;margin-top:-9.6px;left:87.7388%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span><span class="g-cstyle6">,</span>8<span class="g-cstyle2">9</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-478" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2722%;margin-top:-9.6px;left:93.5893%;width:65px;">
      <p class="g-pstyle15"> <span class="g-cstyle4">1</span><span class="g-cstyle12">4</span>,5<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-479" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.3456%;margin-top:-9.6px;left:35.2176%;width:60px;">
      <p class="g-pstyle27">5<span class="g-cstyle15">4</span>,55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-480" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.3456%;margin-top:-9.6px;left:45.4895%;width:41px;">
      <p class="g-pstyle20"><span class="g-cstyle3">3</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-481" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.3456%;margin-top:-9.6px;left:54.7846%;width:39px;">
      <p class="g-pstyle15">-7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-482" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.3456%;margin-top:-9.6px;left:71.0612%;width:65px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle13">7</span><span class="g-cstyle14">,</span><span class="g-cstyle19">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-483" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.3089%;margin-top:-9.1px;left:78.6905%;width:63px;">
      <p class="g-pstyle50">6<span class="g-cstyle28">4</span>,25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-484" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2349%;margin-top:-8.1px;left:3.4768%;width:40px;">
      <p class="g-pstyle31">42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-485" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.423833088137%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.423833088137%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.423833088137%;top:71.1279%;margin-top:-14.6px;left:57.4096%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-486" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.5573%;margin-top:-9.1px;left:8.3505%;width:126px;">
      <p class="g-pstyle19"><span class="g-cstyle10">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>V<span class="g-cstyle3">i</span>ña<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Ma<span class="g-cstyle1">r</span></p>
    </div>
    <div id="g-ai0-487" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.594%;margin-top:-9.6px;left:61.8485%;width:34px;">
      <p class="g-pstyle14"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai0-488" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:87.7491%;width:59px;">
      <p class="g-pstyle15"> <span class="g-cstyle37">9</span>,2<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-489" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:93.6203%;width:63px;">
      <p class="g-pstyle15"> <span class="g-cstyle2">1</span>2,<span class="g-cstyle2">1</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-490" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:35.2485%;width:58px;">
      <p class="g-pstyle16"><span class="g-cstyle2">5</span><span class="g-cstyle16">0</span>,<span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-491" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:45.4381%;width:38px;">
      <p class="g-pstyle14"><span class="g-cstyle2">4</span>2</p>
    </div>
    <div id="g-ai0-492" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:54.8052%;width:37px;">
      <p class="g-pstyle20"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-493" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6674%;margin-top:-9.6px;left:70.9378%;width:64px;">
      <p class="g-pstyle15"> 2<span class="g-cstyle15">4</span><span class="g-cstyle2">,</span>43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-494" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7041%;margin-top:-9.1px;left:78.6905%;width:63px;">
      <p class="g-pstyle51">55,40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-495" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6301%;margin-top:-8.1px;left:3.4768%;width:37px;">
      <p class="g-pstyle18"><span class="g-cstyle9">4</span>3</p>
    </div>
    <div id="g-ai0-496" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.4240620611249%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.4240620611249%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.4240620611249%;top:72.5965%;margin-top:-14.6px;left:57.4095%;margin-left:-15px;width:30px;">
      <p class="g-pstyle25">&rsaquo;</p>
    </div>
    <div id="g-ai0-497" class="g-Layer_1 g-aiAbs" style="top:74.6818%;left:2.9025%;width:94.8936%;">
      <p>Fuente: www.mifuturo.cl, Mineduc // Indicadores: Años acreditados: siete años es el máximo que otorga la CNA, la fecha de cierre es el 10 de diciembre de 2021 / Estudiantes/JCE: entrega el número de estudiantes de pregrado y posgrado por el número de Jornadas Completas Equivalentes (JCE) del año 2021. Una JCE corresponde a 44 horas académicas contratadas a la semana por una institución / Retención de alumnos al 2&ordm; año: expresa al porcentaje de estudiantes que estando matriculados en una carrera como estudiantes de segundo año, continuaron matriculados en la misma institución y en la misma generación de origen al año siguiente, se utilizaron las cohortes 2018 y 2019, y solo se calcula cuando existen, al menos, 25 casos de las cohortes correspondientes / Duración programas en semestres: la duración formal de una carrera es la mínima esperada considerando el n&ordm; de semestres y la titulación, y la duración real es lo que tardaron los alumnos en titularse y se calcula con los estudiantes titulados en 2020// Referencia metodológica: en la tabla se aprecian las cifras que registran las instituciones en cada uno de los indicadores. Para obtener el índice ponderado, estas fueron normalizadas estadísticamente, reescalándolas respecto del máximo valor del parámetro. De esta manera, la institución que presenta el mejor desempeño en el indicador tiene 100 puntos. Se ponderó un 50% los años acreditados, un 20% estudiantes/JCE, un 15% retención de 2&ordm; año y un 15% la diferencia entre la duración formal y real de los programas expresados en semestres.// (*) La U. Adventista de Chile ingresa por primera vez al Ranking de Universidades // En este ranking no se registra la información de las universidades Gabriela Mistral, de Aconcagua, del Alba, ex U. Pedro de Valdivia, Miguel de Cervantes y Bolivariana, ya que no poseen acreditación, a ellas se suman la UNIACC e Internacional SEK, que si bien cuentan con 3 años de acreditación cada una, sus umbrales de investigación son incipientes, por lo que no es posible incluirla en el Ranking de Universidades. </p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-calidad-de-la-gestion-mobile" class="g-artboard" style="max-width: 320px;max-height: 1849px" data-aspect-ratio="0.173" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 577.7778% 0;"></div>
    <img id="g-calidad-de-la-gestion-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:0.6226%;margin-top:-20.5px;left:0.309%;width:28px;">
      <p class="g-pstyle0"> </p>
    </div>
    <div id="g-ai1-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:0.9588%;margin-top:-13.7px;left:1.7904%;width:94px;">
      <p class="g-pstyle1">Ran<span class="g-cstyle0">k</span>in<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai1-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:0.9588%;margin-top:-13.7px;left:27.0931%;width:243px;">
      <p class="g-pstyle2"><span class="g-cstyle0">d</span>e cal<span class="g-cstyle0">i</span>d<span class="g-cstyle0">a</span>d <span class="g-cstyle0">d</span>e <span class="g-cstyle0">l</span>a<span class="g-cstyle0"> g</span>es<span class="g-cstyle0">ti</span>ó<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.2583%;margin-top:-7.2px;left:58.5936%;width:53px;">
      <p class="g-pstyle3"><span class="g-cstyle0">Í</span>n<span class="g-cstyle0">d</span>i<span class="g-cstyle0">c</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.2336%;margin-top:-6.8px;left:84.5766%;width:46px;">
      <p class="g-pstyle4">Mov. </p>
    </div>
    <div id="g-ai1-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.323%;margin-top:-8.4px;left:11.1184%;width:95px;">
      <p class="g-pstyle5">Univ<span class="g-cstyle0">ers</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.3324%;margin-top:-7.6px;left:3.0678%;width:39px;">
      <p class="g-pstyle6">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.2877%;margin-top:-6.8px;left:73.6635%;width:35px;">
      <p class="g-pstyle7"><span class="g-cstyle0">R</span>K</p>
    </div>
    <div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.2877%;margin-top:-6.8px;left:77.9451%;width:24px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.9273%;margin-top:-7.6px;left:3.5134%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.8826%;margin-top:-6.8px;left:54.8806%;width:73px;">
      <p class="g-pstyle3"><span class="g-cstyle0">p</span>onder<span class="g-cstyle0">a</span>d<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.8826%;margin-top:-6.8px;left:73.3907%;width:37px;">
      <p class="g-pstyle3"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.8826%;margin-top:-6.8px;left:81.3842%;width:58px;">
      <p class="g-pstyle4">&rsquo;<span class="g-cstyle0">2</span>0 a &rsquo;<span class="g-cstyle0">2</span><span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.2967%;margin-top:-11.4px;left:90.3686%;width:29px;">
      <p class="g-pstyle8">&bull;</p>
    </div>
    <div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.199%;margin-top:-7.6px;left:11.1184%;width:87px;">
      <p class="g-pstyle9"><span class="g-cstyle2">P</span>UC <span class="g-cstyle2">de </span>C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3071%;margin-top:-7.6px;left:58.7911%;width:52px;">
      <p class="g-pstyle10">9<span class="g-cstyle2">1</span>,<span class="g-cstyle2">4</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3071%;margin-top:-7.6px;left:75.0246%;width:30px;">
      <p class="g-pstyle11"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3071%;margin-top:-7.6px;left:85.9136%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">=</span> </p>
    </div>
    <div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.2624%;margin-top:-6.8px;left:4.7017%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle4">1</span> </p>
    </div>
    <div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.108%;margin-top:-11.4px;left:90.3686%;width:29px;">
      <p class="g-pstyle8">&bull;</p>
    </div>
    <div id="g-ai1-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0644%;margin-top:-7.6px;left:11.1184%;width:75px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e C</span>hi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1184%;margin-top:-7.6px;left:58.6925%;width:54px;">
      <p class="g-pstyle10">8<span class="g-cstyle2">5</span>,<span class="g-cstyle2">4</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1184%;margin-top:-7.6px;left:74.9502%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai1-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1184%;margin-top:-7.6px;left:85.9136%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">=</span> </p>
    </div>
    <div id="g-ai1-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0737%;margin-top:-6.8px;left:4.6273%;width:30px;">
      <p class="g-pstyle12"><span class="g-cstyle4">2</span> </p>
    </div>
    <div id="g-ai1-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.8757%;margin-top:-7.6px;left:11.1184%;width:134px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle2">S</span>a<span class="g-cstyle2">n</span>t<span class="g-cstyle2">ia</span>go <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.9297%;margin-top:-7.6px;left:58.6925%;width:54px;">
      <p class="g-pstyle10">8<span class="g-cstyle6">4</span>,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.9297%;margin-top:-7.6px;left:74.9251%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">8</span> </p>
    </div>
    <div id="g-ai1-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.9297%;margin-top:-7.6px;left:86.0869%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.9391%;margin-top:-6.8px;left:4.6523%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">3</span> </p>
    </div>
    <div id="g-ai1-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:7.9193%;margin-top:-11.4px;left:91.679%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.687%;margin-top:-7.6px;left:11.1184%;width:102px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> De</span>s<span class="g-cstyle3">a</span>r<span class="g-cstyle7">r</span>o<span class="g-cstyle3">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7951%;margin-top:-7.6px;left:58.9153%;width:51px;">
      <p class="g-pstyle10">8<span class="g-cstyle6">4</span><span class="g-cstyle8">,</span>7<span class="g-cstyle2">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7951%;margin-top:-7.6px;left:74.9251%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">9</span> </p>
    </div>
    <div id="g-ai1-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7951%;margin-top:-7.6px;left:86.0869%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7504%;margin-top:-6.8px;left:4.5534%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">4</span> </p>
    </div>
    <div id="g-ai1-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:8.7306%;margin-top:-11.4px;left:91.679%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.5523%;margin-top:-7.6px;left:11.1184%;width:108px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">on</span>cepc<span class="g-cstyle2">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.6064%;margin-top:-7.6px;left:58.89%;width:54px;">
      <p class="g-pstyle10">8<span class="g-cstyle9">3</span>,3<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.6064%;margin-top:-7.6px;left:74.9746%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai1-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.6064%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.5617%;margin-top:-6.8px;left:4.6523%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">5</span> </p>
    </div>
    <div id="g-ai1-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:9.5419%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.3636%;margin-top:-7.6px;left:11.1184%;width:106px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span><span class="g-cstyle10">F</span><span class="g-cstyle7">r</span><span class="g-cstyle2">o</span>nt<span class="g-cstyle2">e</span>r<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4718%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4718%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle10">7<span class="g-cstyle9">8</span><span class="g-cstyle11">,</span>98<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4718%;margin-top:-7.6px;left:74.8757%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai1-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4271%;margin-top:-6.8px;left:4.6029%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">6</span> </p>
    </div>
    <div id="g-ai1-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:10.4613%;margin-top:-11.4px;left:91.8065%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.229%;margin-top:-7.6px;left:11.1184%;width:102px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">d</span>o<span class="g-cstyle2">l</span>fo<span class="g-cstyle2"> </span>Ib<span class="g-cstyle2">áñ</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2831%;margin-top:-7.6px;left:58.9895%;width:51px;">
      <p class="g-pstyle16"><span class="g-cstyle3">7</span><span class="g-cstyle9">8</span>,5<span class="g-cstyle3">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2831%;margin-top:-7.6px;left:73.9846%;width:36px;">
      <p class="g-pstyle13">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2831%;margin-top:-7.6px;left:86.1605%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2384%;margin-top:-6.8px;left:4.6767%;width:30px;">
      <p class="g-pstyle12"><span class="g-cstyle4">7</span> </p>
    </div>
    <div id="g-ai1-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:11.1645%;margin-top:-11.4px;left:91.7287%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.0403%;margin-top:-7.6px;left:11.1184%;width:111px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Aus<span class="g-cstyle2">t</span>r<span class="g-cstyle2">al</span> <span class="g-cstyle2">de</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.0944%;margin-top:-7.6px;left:58.9647%;width:52px;">
      <p class="g-pstyle10">7<span class="g-cstyle12">7</span><span class="g-cstyle6">,</span><span class="g-cstyle2">0</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.0944%;margin-top:-7.6px;left:75.0002%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.0944%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.0497%;margin-top:-6.8px;left:4.6029%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">8</span> </p>
    </div>
    <div id="g-ai1-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:11.9758%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.8516%;margin-top:-7.6px;left:11.1184%;width:77px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle13">T</span><span class="g-cstyle2">a</span>l<span class="g-cstyle2">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9598%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle10">76,2<span class="g-cstyle2">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9598%;margin-top:-7.6px;left:74.9251%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9598%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9151%;margin-top:-6.8px;left:4.6029%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle4">9</span> </p>
    </div>
    <div id="g-ai1-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:12.8411%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.717%;margin-top:-7.6px;left:11.1184%;width:98px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e l</span>os<span class="g-cstyle3"> A</span>nd<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.7711%;margin-top:-7.6px;left:58.94%;width:53px;">
      <p class="g-pstyle10">7<span class="g-cstyle2">5</span><span class="g-cstyle10">,</span>63<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.7711%;margin-top:-7.6px;left:74.9746%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai1-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.7711%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.7264%;margin-top:-6.8px;left:3.7612%;width:35px;">
      <p class="g-pstyle17">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:13.7606%;margin-top:-11.4px;left:91.8056%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.5283%;margin-top:-7.6px;left:11.1184%;width:121px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle7">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el No<span class="g-cstyle2">r</span>te<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.5824%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.5824%;margin-top:-7.6px;left:58.94%;width:51px;">
      <p class="g-pstyle10"><span class="g-cstyle8">7</span><span class="g-cstyle10">4</span>,<span class="g-cstyle2">2</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.5824%;margin-top:-7.6px;left:73.9846%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.5918%;margin-top:-6.8px;left:3.8857%;width:33px;">
      <p class="g-pstyle17">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:14.5178%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3396%;margin-top:-7.6px;left:11.1184%;width:112px;">
      <p class="g-pstyle13">P<span class="g-cstyle3">UC </span>de <span class="g-cstyle14">V</span>al<span class="g-cstyle3">p</span>a<span class="g-cstyle3">r</span>aís<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.4478%;margin-top:-7.6px;left:58.9153%;width:51px;">
      <p class="g-pstyle10"><span class="g-cstyle8">7</span><span class="g-cstyle10">4</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.4478%;margin-top:-7.6px;left:74.1335%;width:34px;">
      <p class="g-pstyle13">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.4478%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.4031%;margin-top:-6.8px;left:3.8106%;width:35px;">
      <p class="g-pstyle17">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:15.3291%;margin-top:-11.4px;left:91.8306%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.205%;margin-top:-7.6px;left:11.1184%;width:133px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">dv</span>en<span class="g-cstyle2">ti</span>sta <span class="g-cstyle2">de</span> C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2591%;margin-top:-7.6px;left:58.94%;width:52px;">
      <p class="g-pstyle10">7<span class="g-cstyle9">3</span><span class="g-cstyle10">,</span><span class="g-cstyle2">0</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2591%;margin-top:-7.6px;left:75.9646%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2591%;margin-top:-7.6px;left:87.0525%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2144%;margin-top:-6.8px;left:3.8363%;width:35px;">
      <p class="g-pstyle17">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0163%;margin-top:-7.6px;left:11.1184%;width:123px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle7">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el <span class="g-cstyle2">Ma</span>ule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.1245%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle10">7<span class="g-cstyle2">2</span><span class="g-cstyle10">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.1245%;margin-top:-7.6px;left:74.0841%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.1245%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.0798%;margin-top:-6.8px;left:3.7368%;width:35px;">
      <p class="g-pstyle17">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:17.0058%;margin-top:-11.4px;left:91.8065%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8276%;margin-top:-7.6px;left:11.1184%;width:130px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> C</span><span class="g-cstyle7">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>ica<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle15">T</span>e<span class="g-cstyle3">mu</span>co<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.9358%;margin-top:-7.6px;left:58.89%;width:53px;">
      <p class="g-pstyle10">7<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.9358%;margin-top:-7.6px;left:73.9846%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.9358%;margin-top:-7.6px;left:86.1605%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8911%;margin-top:-6.8px;left:3.8363%;width:35px;">
      <p class="g-pstyle17">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:17.8712%;margin-top:-11.4px;left:91.7287%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.693%;margin-top:-7.6px;left:11.1184%;width:145px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C. R<span class="g-cstyle2">a</span>úl S<span class="g-cstyle2">i</span>l<span class="g-cstyle2">va</span> <span class="g-cstyle2">H</span>e<span class="g-cstyle2">n</span>r<span class="g-cstyle2">í</span>q<span class="g-cstyle2">u</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.7471%;margin-top:-7.6px;left:86.0869%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai1-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.7471%;margin-top:-7.6px;left:58.7417%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle17">9</span>,88<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.7471%;margin-top:-7.6px;left:74.0346%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.7024%;margin-top:-6.8px;left:3.7862%;width:35px;">
      <p class="g-pstyle17">16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:18.6825%;margin-top:-11.4px;left:91.729%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5043%;margin-top:-7.6px;left:11.1184%;width:100px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e L<span class="g-cstyle2">o</span>s<span class="g-cstyle2"> </span>L<span class="g-cstyle2">a</span>go<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.6124%;margin-top:-7.6px;left:58.7911%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle17">9</span><span class="g-cstyle2">,</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.6124%;margin-top:-7.6px;left:74.0841%;width:36px;">
      <p class="g-pstyle9">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.6124%;margin-top:-7.6px;left:85.2697%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle18">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5678%;margin-top:-6.8px;left:3.8601%;width:35px;">
      <p class="g-pstyle17">17<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:19.5479%;margin-top:-11.4px;left:91.6781%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3697%;margin-top:-7.6px;left:11.1184%;width:161px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Playa A. d<span class="g-cstyle2">e</span> C<span class="g-cstyle2">s</span>. <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> la</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4237%;margin-top:-7.6px;left:58.8405%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle17">9</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4237%;margin-top:-7.6px;left:74.059%;width:36px;">
      <p class="g-pstyle13">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4237%;margin-top:-7.6px;left:86.0869%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai1-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.3791%;margin-top:-6.8px;left:3.7862%;width:35px;">
      <p class="g-pstyle17">18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:20.3051%;margin-top:-11.4px;left:91.6787%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.181%;margin-top:-7.6px;left:11.1184%;width:111px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3">T.</span>F.<span class="g-cstyle3"> S</span>an<span class="g-cstyle3">t</span>a<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">rí</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.235%;margin-top:-7.6px;left:58.8158%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle17">9</span>,<span class="g-cstyle2">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.235%;margin-top:-7.6px;left:74.0346%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.235%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.1904%;margin-top:-6.8px;left:3.7862%;width:35px;">
      <p class="g-pstyle17">19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:21.1705%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.9923%;margin-top:-7.6px;left:11.1184%;width:109px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e A<span class="g-cstyle2">n</span>t<span class="g-cstyle19">o</span>f<span class="g-cstyle2">a</span>g<span class="g-cstyle2">a</span>sta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.1004%;margin-top:-7.6px;left:58.9153%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle9">8</span><span class="g-cstyle8">,</span>77<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.1004%;margin-top:-7.6px;left:74.0346%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.1004%;margin-top:-7.6px;left:85.2697%;width:36px;">
      <p class="g-pstyle9">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.0557%;margin-top:-6.8px;left:3.6873%;width:36px;">
      <p class="g-pstyle17">20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:21.9818%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.8576%;margin-top:-7.6px;left:11.1184%;width:67px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">y</span>o<span class="g-cstyle3">r</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.9117%;margin-top:-7.6px;left:58.6925%;width:54px;">
      <p class="g-pstyle10">6<span class="g-cstyle9">8</span><span class="g-cstyle2">,</span>49<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.9117%;margin-top:-7.6px;left:74.0841%;width:36px;">
      <p class="g-pstyle13">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.9117%;margin-top:-7.6px;left:85.2944%;width:36px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.867%;margin-top:-6.8px;left:3.8106%;width:35px;">
      <p class="g-pstyle17">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:22.8472%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.6689%;margin-top:-7.6px;left:11.1184%;width:105px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>Mag<span class="g-cstyle3">a</span>l<span class="g-cstyle3">l</span>ane<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7771%;margin-top:-7.6px;left:58.7417%;width:53px;">
      <p class="g-pstyle16"><span class="g-cstyle3">6</span><span class="g-cstyle9">8</span>,<span class="g-cstyle3">4</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7771%;margin-top:-7.6px;left:73.9596%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7771%;margin-top:-7.6px;left:86.0128%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7324%;margin-top:-6.8px;left:3.7368%;width:36px;">
      <p class="g-pstyle17">22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:23.6585%;margin-top:-11.4px;left:91.6784%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.4802%;margin-top:-7.6px;left:11.1184%;width:101px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle14">V</span>a<span class="g-cstyle3">l</span>pa<span class="g-cstyle3">r</span>a<span class="g-cstyle3">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.5884%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle16"><span class="g-cstyle3">6</span><span class="g-cstyle9">8</span>,<span class="g-cstyle3">3</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.5884%;margin-top:-7.6px;left:74.1085%;width:36px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.5884%;margin-top:-7.6px;left:85.2944%;width:36px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.5437%;margin-top:-6.8px;left:3.7612%;width:37px;">
      <p class="g-pstyle17">23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:24.5238%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.3456%;margin-top:-7.6px;left:11.1184%;width:135px;">
      <p class="g-pstyle9"><span class="g-cstyle2">U</span>C <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> </span>la<span class="g-cstyle2"> </span>S. C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">c</span>ep<span class="g-cstyle2">ci</span>ón<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.3997%;margin-top:-7.6px;left:58.89%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle12">7</span><span class="g-cstyle11">,</span>9<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.3997%;margin-top:-7.6px;left:73.9351%;width:38px;">
      <p class="g-pstyle9">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.3997%;margin-top:-7.6px;left:86.0375%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle2">6</span> </p>
    </div>
    <div id="g-ai1-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.355%;margin-top:-6.8px;left:3.6873%;width:37px;">
      <p class="g-pstyle17">24<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:25.3351%;margin-top:-11.4px;left:91.6784%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.1569%;margin-top:-7.6px;left:11.1184%;width:96px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>nd<span class="g-cstyle19">r</span><span class="g-cstyle3">é</span>s<span class="g-cstyle3"> </span>B<span class="g-cstyle3">e</span>l<span class="g-cstyle3">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.2651%;margin-top:-7.6px;left:58.9647%;width:52px;">
      <p class="g-pstyle16"><span class="g-cstyle3">6</span><span class="g-cstyle12">7</span>,5<span class="g-cstyle3">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.2651%;margin-top:-7.6px;left:74.0096%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.2651%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.2204%;margin-top:-6.8px;left:3.7612%;width:36px;">
      <p class="g-pstyle17">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:26.1464%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0223%;margin-top:-7.6px;left:11.1184%;width:106px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> D</span>i<span class="g-cstyle3">e</span>go<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>r<span class="g-cstyle3">t</span>a<span class="g-cstyle3">l</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0764%;margin-top:-7.6px;left:58.9895%;width:51px;">
      <p class="g-pstyle10">6<span class="g-cstyle12">7</span>,4<span class="g-cstyle2">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0764%;margin-top:-7.6px;left:73.9101%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0764%;margin-top:-7.6px;left:85.2944%;width:36px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0317%;margin-top:-6.8px;left:3.7111%;width:36px;">
      <p class="g-pstyle17">26<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:27.0118%;margin-top:-11.4px;left:91.8306%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8336%;margin-top:-7.6px;left:11.1184%;width:104px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>n <span class="g-cstyle2">S</span>eb<span class="g-cstyle2">as</span>t<span class="g-cstyle2">i</span>á<span class="g-cstyle2">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8877%;margin-top:-7.6px;left:58.8405%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle12">7</span><span class="g-cstyle6">,</span><span class="g-cstyle2">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8877%;margin-top:-7.6px;left:74.059%;width:36px;">
      <p class="g-pstyle13">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8877%;margin-top:-7.6px;left:84.5766%;width:41px;">
      <p class="g-pstyle9">-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.843%;margin-top:-6.8px;left:3.7856%;width:36px;">
      <p class="g-pstyle17">27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:27.8231%;margin-top:-11.4px;left:91.8056%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.6449%;margin-top:-7.6px;left:11.1184%;width:88px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle20">-</span><span class="g-cstyle3">Bí</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.7531%;margin-top:-7.6px;left:58.7664%;width:53px;">
      <p class="g-pstyle16"><span class="g-cstyle3">66</span>,58<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.7531%;margin-top:-7.6px;left:73.9101%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.7531%;margin-top:-7.6px;left:85.2697%;width:36px;">
      <p class="g-pstyle9">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.7084%;margin-top:-6.8px;left:3.7111%;width:36px;">
      <p class="g-pstyle17">28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:28.6344%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.5103%;margin-top:-7.6px;left:11.1184%;width:91px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Fi<span class="g-cstyle2">n</span>i<span class="g-cstyle2">s </span><span class="g-cstyle15">T</span>er<span class="g-cstyle2">ra</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.5644%;margin-top:-7.6px;left:58.89%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">5</span><span class="g-cstyle10">,</span>67<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.5644%;margin-top:-7.6px;left:74.0096%;width:38px;">
      <p class="g-pstyle13">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.5644%;margin-top:-7.6px;left:85.2697%;width:36px;">
      <p class="g-pstyle9">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.5197%;margin-top:-6.8px;left:3.7111%;width:36px;">
      <p class="g-pstyle17">29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:29.5539%;margin-top:-11.4px;left:91.7571%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.3216%;margin-top:-7.6px;left:11.1184%;width:95px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle13">T</span>a<span class="g-cstyle3">r</span>apa<span class="g-cstyle3">c</span>á<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.3757%;margin-top:-7.6px;left:58.89%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle9">3</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.3757%;margin-top:-7.6px;left:74.0346%;width:37px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.3757%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.3851%;margin-top:-6.8px;left:3.7111%;width:37px;">
      <p class="g-pstyle17">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:30.3111%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.1329%;margin-top:-7.6px;left:11.1184%;width:126px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Aut<span class="g-cstyle2">ó</span>n<span class="g-cstyle2">o</span>m<span class="g-cstyle2">a</span> d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.2411%;margin-top:-7.6px;left:58.7417%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">2</span>,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.2411%;margin-top:-7.6px;left:73.9351%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.2411%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.1964%;margin-top:-6.8px;left:3.8363%;width:35px;">
      <p class="g-pstyle17">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:31.1224%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.9983%;margin-top:-7.6px;left:11.1184%;width:128px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Be<span class="g-cstyle2">r</span>n<span class="g-cstyle2">ardo</span> O<span class="g-cstyle2">&rsquo;</span>H<span class="g-cstyle2">i</span>ggin<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0523%;margin-top:-7.6px;left:58.7911%;width:53px;">
      <p class="g-pstyle16"><span class="g-cstyle3">6</span>2<span class="g-cstyle10">,</span><span class="g-cstyle3">6</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0523%;margin-top:-7.6px;left:73.9596%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0523%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.0077%;margin-top:-6.8px;left:3.7612%;width:37px;">
      <p class="g-pstyle17">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:31.9878%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8096%;margin-top:-7.6px;left:11.1184%;width:99px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span>Se<span class="g-cstyle19">r</span>e<span class="g-cstyle2">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.9177%;margin-top:-7.6px;left:58.7169%;width:53px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">2</span>,<span class="g-cstyle2">4</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.9177%;margin-top:-7.6px;left:74.059%;width:38px;">
      <p class="g-pstyle9">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.9177%;margin-top:-7.6px;left:86.0128%;width:32px;">
      <p class="g-pstyle11"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.873%;margin-top:-6.8px;left:3.7856%;width:37px;">
      <p class="g-pstyle17">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:32.8532%;margin-top:-11.4px;left:91.6787%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6209%;margin-top:-7.6px;left:11.1184%;width:112px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>l<span class="g-cstyle3">b</span>e<span class="g-cstyle3">r</span>to<span class="g-cstyle3"> </span>H<span class="g-cstyle3">u</span>r<span class="g-cstyle3">t</span>ad<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.729%;margin-top:-7.6px;left:58.8405%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">1</span>,<span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.729%;margin-top:-7.6px;left:74.0096%;width:38px;">
      <p class="g-pstyle9">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.729%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6843%;margin-top:-6.8px;left:3.6873%;width:37px;">
      <p class="g-pstyle17">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:33.6645%;margin-top:-11.4px;left:91.856%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.4862%;margin-top:-7.6px;left:11.1184%;width:115px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2">s</span> Amé<span class="g-cstyle2">r</span>i<span class="g-cstyle2">ca</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.5403%;margin-top:-7.6px;left:58.94%;width:53px;">
      <p class="g-pstyle10"><span class="g-cstyle2">5</span><span class="g-cstyle17">9</span>,<span class="g-cstyle2">5</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.5403%;margin-top:-7.6px;left:74.0346%;width:38px;">
      <p class="g-pstyle9">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.5403%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.4956%;margin-top:-6.8px;left:3.7856%;width:37px;">
      <p class="g-pstyle17">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:34.4217%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.2975%;margin-top:-7.6px;left:11.1184%;width:98px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>nt<span class="g-cstyle2">o</span> <span class="g-cstyle15">T</span>om<span class="g-cstyle2">ás</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4057%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle16">5<span class="g-cstyle17">9</span><span class="g-cstyle10">,</span><span class="g-cstyle3">0</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4057%;margin-top:-7.6px;left:73.9846%;width:36px;">
      <p class="g-pstyle13">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4057%;margin-top:-7.6px;left:86.0869%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.361%;margin-top:-6.8px;left:3.7368%;width:37px;">
      <p class="g-pstyle17">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:35.3411%;margin-top:-11.4px;left:91.7037%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1629%;margin-top:-7.6px;left:11.1184%;width:154px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">M</span>et<span class="g-cstyle19">r</span><span class="g-cstyle2">o.</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">s</span>. d<span class="g-cstyle2">e</span> l<span class="g-cstyle2">a</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.217%;margin-top:-7.6px;left:58.7169%;width:53px;">
      <p class="g-pstyle16">5<span class="g-cstyle9">8</span><span class="g-cstyle10">,</span><span class="g-cstyle3">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.217%;margin-top:-7.6px;left:73.9351%;width:38px;">
      <p class="g-pstyle9">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.217%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1723%;margin-top:-6.8px;left:3.8106%;width:36px;">
      <p class="g-pstyle17">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:36.1524%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9742%;margin-top:-7.6px;left:11.1184%;width:94px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle7">A</span>ta<span class="g-cstyle3">c</span>a<span class="g-cstyle3">m</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.0283%;margin-top:-7.6px;left:58.9895%;width:52px;">
      <p class="g-pstyle10"><span class="g-cstyle2">5</span><span class="g-cstyle12">7</span><span class="g-cstyle11">,</span>99<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.0283%;margin-top:-7.6px;left:73.8363%;width:38px;">
      <p class="g-pstyle9"><span class="g-cstyle2">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.0283%;margin-top:-7.6px;left:86.0869%;width:31px;">
      <p class="g-pstyle11"><span class="g-cstyle3">2</span> </p>
    </div>
    <div id="g-ai1-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.0377%;margin-top:-6.8px;left:3.7368%;width:37px;">
      <p class="g-pstyle17">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:36.9637%;margin-top:-11.4px;left:91.6787%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle14">&rsaquo;</p>
    </div>
    <div id="g-ai1-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.7855%;margin-top:-7.6px;left:11.1184%;width:121px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span><span class="g-cstyle15">Tec. </span>M<span class="g-cstyle3">et</span><span class="g-cstyle19">r</span>o<span class="g-cstyle3">po</span>li<span class="g-cstyle3">t</span>an<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.8937%;margin-top:-7.6px;left:59.0877%;width:51px;">
      <p class="g-pstyle10"><span class="g-cstyle2">5</span><span class="g-cstyle12">7</span><span class="g-cstyle8">,</span>79<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.8937%;margin-top:-7.6px;left:73.9596%;width:38px;">
      <p class="g-pstyle9">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.8937%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.849%;margin-top:-6.8px;left:3.7368%;width:37px;">
      <p class="g-pstyle17">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:37.8291%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6509%;margin-top:-7.6px;left:11.1184%;width:112px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Ce<span class="g-cstyle2">nt</span>r<span class="g-cstyle2">a</span>l <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">il</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.705%;margin-top:-7.6px;left:58.8158%;width:53px;">
      <p class="g-pstyle10"><span class="g-cstyle2">5</span>6,<span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.705%;margin-top:-7.6px;left:73.9846%;width:38px;">
      <p class="g-pstyle9">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.705%;margin-top:-7.6px;left:85.2697%;width:36px;">
      <p class="g-pstyle9">-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6603%;margin-top:-6.8px;left:3.6123%;width:37px;">
      <p class="g-pstyle17">40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:38.5863%;margin-top:-11.4px;left:91.7818%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.4622%;margin-top:-7.6px;left:11.1184%;width:88px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>r<span class="g-cstyle3">t</span>u<span class="g-cstyle7">r</span>o <span class="g-cstyle3">P</span>r<span class="g-cstyle7">a</span>t<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5163%;margin-top:-7.6px;left:58.7664%;width:53px;">
      <p class="g-pstyle16">55<span class="g-cstyle10">,</span><span class="g-cstyle3">0</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5163%;margin-top:-7.6px;left:73.9846%;width:38px;">
      <p class="g-pstyle9">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5163%;margin-top:-7.6px;left:85.3438%;width:36px;">
      <p class="g-pstyle9">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.5257%;margin-top:-6.8px;left:3.7368%;width:35px;">
      <p class="g-pstyle17">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:39.4517%;margin-top:-11.4px;left:91.7809%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2735%;margin-top:-7.6px;left:11.1184%;width:124px;">
      <p class="g-pstyle9"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Ac. <span class="g-cstyle2">de</span> <span class="g-cstyle2">H. </span>Cri<span class="g-cstyle2">s</span>t<span class="g-cstyle2">ia</span>no<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3817%;margin-top:-7.6px;left:58.8653%;width:53px;">
      <p class="g-pstyle16">5<span class="g-cstyle6">4</span>,55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3817%;margin-top:-7.6px;left:74.0346%;width:38px;">
      <p class="g-pstyle13"><span class="g-cstyle3">3</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.3817%;margin-top:-7.6px;left:85.4186%;width:36px;">
      <p class="g-pstyle9">-7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.337%;margin-top:-6.8px;left:3.6873%;width:37px;">
      <p class="g-pstyle17">42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:40.263%;margin-top:-11.4px;left:91.8065%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.1389%;margin-top:-7.6px;left:11.1184%;width:108px;">
      <p class="g-pstyle13"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>V<span class="g-cstyle3">i</span>ña<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Ma<span class="g-cstyle1">r</span></p>
    </div>
    <div id="g-ai1-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.193%;margin-top:-7.6px;left:58.94%;width:52px;">
      <p class="g-pstyle10"><span class="g-cstyle2">5</span><span class="g-cstyle16">0</span>,<span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.193%;margin-top:-7.6px;left:73.9101%;width:35px;">
      <p class="g-pstyle11"><span class="g-cstyle2">4</span>2</p>
    </div>
    <div id="g-ai1-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.193%;margin-top:-7.6px;left:85.468%;width:34px;">
      <p class="g-pstyle13"><span class="g-cstyle3">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.1483%;margin-top:-6.8px;left:3.6873%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle4">4</span>3</p>
    </div>
    <div id="g-ai1-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 54.3788753474449%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 54.3788753474449%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 54.3788753474449%;top:41.1825%;margin-top:-11.4px;left:91.8059%;margin-left:-14.5px;width:29px;">
      <p class="g-pstyle15">&rsaquo;</p>
    </div>
    <div id="g-ai1-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.0562%;margin-top:-7.1px;left:9.1787%;width:81px;">
      <p class="g-pstyle18">Univ<span class="g-cstyle0">ers</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.0198%;margin-top:-6.4px;left:2.6186%;width:36px;">
      <p class="g-pstyle19">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.974%;margin-top:-4.5px;left:43.0694%;width:41px;">
      <p class="g-pstyle20"><span class="g-cstyle0">A</span>ños<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.974%;margin-top:-4.5px;left:52.1502%;width:61px;">
      <p class="g-pstyle21">Estudiantes<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.974%;margin-top:-4.5px;left:65.1772%;width:57px;">
      <p class="g-pstyle20">R<span class="g-cstyle0">e</span>tenci<span class="g-cstyle0">ó</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.974%;margin-top:-4.5px;left:77.5744%;width:92px;">
      <p class="g-pstyle20"><span class="g-cstyle0">D</span>uraci<span class="g-cstyle0">ó</span>n<span class="g-cstyle0"> </span>prog<span class="g-cstyle0">r</span>a<span class="g-cstyle0">m</span>as<span class="g-cstyle0"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.5066%;margin-top:-6.4px;left:2.9818%;width:33px;">
      <p class="g-pstyle19"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4608%;margin-top:-4.5px;left:39.5397%;width:60px;">
      <p class="g-pstyle22">acreditado<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4608%;margin-top:-4.5px;left:55.4778%;width:39px;">
      <p class="g-pstyle20">/<span class="g-cstyle0"> </span>JC<span class="g-cstyle1">E</span></p>
    </div>
    <div id="g-ai1-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4608%;margin-top:-4.5px;left:64.4518%;width:61px;">
      <p class="g-pstyle20">d<span class="g-cstyle0">e</span> alu<span class="g-cstyle0">mn</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4608%;margin-top:-4.5px;left:81.4061%;width:67px;">
      <p class="g-pstyle20"><span class="g-cstyle0">e</span>n s<span class="g-cstyle0">e</span>m<span class="g-cstyle0">e</span>st<span class="g-cstyle0">r</span>e<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8934%;margin-top:-4.5px;left:78.6828%;width:43px;">
      <p class="g-pstyle23">Forma<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.8934%;margin-top:-4.5px;left:90.1684%;width:35px;">
      <p class="g-pstyle23">Re<span class="g-cstyle0">a</span><span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.9475%;margin-top:-4.5px;left:67.1337%;width:43px;">
      <p class="g-pstyle20">2&deg; añ<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4266%;margin-top:-5.9px;left:9.1787%;width:75px;">
      <p class="g-pstyle24"><span class="g-cstyle2">P</span>UC <span class="g-cstyle2">de </span>C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.3996%;margin-top:-6.4px;left:40.2459%;width:29px;">
      <p class="g-pstyle25"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4537%;margin-top:-6.4px;left:78.7835%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,37<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4537%;margin-top:-6.4px;left:88.9177%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4537%;margin-top:-6.4px;left:54.5702%;width:51px;">
      <p class="g-pstyle26"> 16<span class="g-cstyle10">,</span>0<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4807%;margin-top:-5.9px;left:65.985%;width:49px;">
      <p class="g-pstyle27">8<span class="g-cstyle22">3</span><span class="g-cstyle23">,</span>72%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.4172%;margin-top:-5.7px;left:3.9501%;width:28px;">
      <p class="g-pstyle28"><span class="g-cstyle4">1</span> </p>
    </div>
    <div id="g-ai1-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.0757%;margin-top:-5.9px;left:9.1787%;width:66px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e C</span>hi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1027%;margin-top:-6.4px;left:40.2459%;width:29px;">
      <p class="g-pstyle25"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1028%;margin-top:-6.4px;left:78.7639%;width:49px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle17">0</span><span class="g-cstyle20">,</span>01<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1028%;margin-top:-6.4px;left:88.9782%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,<span class="g-cstyle17">1</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1568%;margin-top:-6.4px;left:54.8522%;width:49px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle12">7</span><span class="g-cstyle25">,</span>78 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-297" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1297%;margin-top:-5.9px;left:65.9643%;width:48px;">
      <p class="g-pstyle31">82,12%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-298" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.1204%;margin-top:-5.7px;left:3.8894%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">2</span> </p>
    </div>
    <div id="g-ai1-299" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.7788%;margin-top:-5.9px;left:9.1787%;width:113px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle2">S</span>a<span class="g-cstyle2">n</span>t<span class="g-cstyle2">ia</span>go <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-300" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.7518%;margin-top:-6.4px;left:40.2459%;width:29px;">
      <p class="g-pstyle25"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-301" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.8058%;margin-top:-6.4px;left:78.8445%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,<span class="g-cstyle2">1</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-302" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.8058%;margin-top:-6.4px;left:88.8781%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>3 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-303" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.8059%;margin-top:-6.4px;left:54.6309%;width:51px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>27 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-304" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.8329%;margin-top:-5.9px;left:66.0048%;width:48px;">
      <p class="g-pstyle32">71<span class="g-cstyle26">,</span>05%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-305" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.8235%;margin-top:-5.7px;left:3.9098%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">3</span> </p>
    </div>
    <div id="g-ai1-306" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4278%;margin-top:-5.9px;left:9.1787%;width:87px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> De</span>s<span class="g-cstyle3">a</span>r<span class="g-cstyle7">r</span>o<span class="g-cstyle3">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-307" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4549%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-308" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4549%;margin-top:-6.4px;left:78.6626%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-309" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4549%;margin-top:-6.4px;left:88.7975%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-310" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.5089%;margin-top:-6.4px;left:54.6309%;width:51px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle6">4</span><span class="g-cstyle2">,</span>29<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-311" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4819%;margin-top:-5.9px;left:65.985%;width:49px;">
      <p class="g-pstyle27">7<span class="g-cstyle22">8</span><span class="g-cstyle23">,</span>78%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-312" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.4725%;margin-top:-5.7px;left:3.8292%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">4</span> </p>
    </div>
    <div id="g-ai1-313" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.131%;margin-top:-5.9px;left:9.1787%;width:92px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">on</span>cepc<span class="g-cstyle2">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-314" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.158%;margin-top:-6.4px;left:40.2459%;width:29px;">
      <p class="g-pstyle25"><span class="g-cstyle3">7</span> </p>
    </div>
    <div id="g-ai1-315" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.158%;margin-top:-6.4px;left:78.7835%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,57 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-316" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.158%;margin-top:-6.4px;left:88.8573%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span><span class="g-cstyle27">,</span>4<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-317" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.158%;margin-top:-6.4px;left:54.6105%;width:51px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle17">9</span>,<span class="g-cstyle2">4</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-318" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.185%;margin-top:-5.9px;left:65.9447%;width:49px;">
      <p class="g-pstyle33">76,56%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-319" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1757%;margin-top:-5.7px;left:3.9098%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">5</span> </p>
    </div>
    <div id="g-ai1-320" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.78%;margin-top:-5.9px;left:9.1787%;width:90px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span><span class="g-cstyle10">F</span><span class="g-cstyle7">r</span><span class="g-cstyle2">o</span>nt<span class="g-cstyle2">e</span>r<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-321" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.807%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-322" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8071%;margin-top:-6.4px;left:78.6626%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle27">,</span>4<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-323" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8071%;margin-top:-6.4px;left:89.0191%;width:49px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle27">,</span><span class="g-cstyle3">4</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-324" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8611%;margin-top:-6.4px;left:54.7115%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">3</span><span class="g-cstyle2">,</span>53 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-325" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8341%;margin-top:-5.9px;left:66.1257%;width:49px;">
      <p class="g-pstyle34">7<span class="g-cstyle28">7</span><span class="g-cstyle29">,</span>97%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-326" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8247%;margin-top:-5.7px;left:3.8695%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">6</span> </p>
    </div>
    <div id="g-ai1-327" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.4831%;margin-top:-5.9px;left:9.1787%;width:87px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">d</span>o<span class="g-cstyle2">l</span>fo<span class="g-cstyle2"> </span>Ib<span class="g-cstyle2">áñ</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-328" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5102%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-329" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5102%;margin-top:-6.4px;left:78.6828%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,2<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-330" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5102%;margin-top:-6.4px;left:88.8573%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle11">,</span>92<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-331" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5102%;margin-top:-6.4px;left:54.7115%;width:50px;">
      <p class="g-pstyle26"> 21<span class="g-cstyle8">,</span>7<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-332" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5372%;margin-top:-5.9px;left:65.9447%;width:49px;">
      <p class="g-pstyle31">8<span class="g-cstyle30">3</span>,81%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-333" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.5278%;margin-top:-5.7px;left:3.9296%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">7</span> </p>
    </div>
    <div id="g-ai1-334" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1322%;margin-top:-5.9px;left:9.1787%;width:94px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Aus<span class="g-cstyle2">t</span>r<span class="g-cstyle2">al</span> <span class="g-cstyle2">de</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-335" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1592%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-336" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1592%;margin-top:-6.4px;left:78.8445%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,<span class="g-cstyle2">1</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-337" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1592%;margin-top:-6.4px;left:88.8372%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-338" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.2133%;margin-top:-6.4px;left:54.6911%;width:50px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle9">8</span><span class="g-cstyle25">,</span><span class="g-cstyle8">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-339" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1862%;margin-top:-5.9px;left:66.0253%;width:49px;">
      <p class="g-pstyle35">7<span class="g-cstyle31">8</span>,13%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-340" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1769%;margin-top:-5.7px;left:3.8695%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">8</span> </p>
    </div>
    <div id="g-ai1-341" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8353%;margin-top:-5.9px;left:9.1787%;width:67px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e <span class="g-cstyle13">T</span><span class="g-cstyle2">a</span>l<span class="g-cstyle2">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-342" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8623%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-343" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8623%;margin-top:-6.4px;left:78.6425%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,50 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-344" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8623%;margin-top:-6.4px;left:88.7975%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>9 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-345" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8624%;margin-top:-6.4px;left:54.5904%;width:51px;">
      <p class="g-pstyle26"> 21<span class="g-cstyle10">,</span>0<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-346" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.8894%;margin-top:-5.9px;left:65.9643%;width:49px;">
      <p class="g-pstyle36">7<span class="g-cstyle32">9</span>,85%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-347" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.88%;margin-top:-5.7px;left:3.8695%;width:29px;">
      <p class="g-pstyle28"><span class="g-cstyle4">9</span> </p>
    </div>
    <div id="g-ai1-348" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4843%;margin-top:-5.9px;left:9.1787%;width:84px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e l</span>os<span class="g-cstyle3"> A</span>nd<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-349" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.5114%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-350" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.5114%;margin-top:-6.4px;left:78.8042%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,<span class="g-cstyle17">1</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-351" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.5114%;margin-top:-6.4px;left:88.8372%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,2<span class="g-cstyle2">6 </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-352" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.5655%;margin-top:-6.4px;left:54.6911%;width:50px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle9">8</span><span class="g-cstyle25">,</span><span class="g-cstyle8">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-353" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.5384%;margin-top:-5.9px;left:65.783%;width:49px;">
      <p class="g-pstyle37">8<span class="g-cstyle33">4</span><span class="g-cstyle34">,</span>90%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-354" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.529%;margin-top:-5.7px;left:3.1838%;width:33px;">
      <p class="g-pstyle38">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-355" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1875%;margin-top:-5.9px;left:9.1787%;width:103px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle7">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el No<span class="g-cstyle2">r</span>te<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-356" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2145%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-357" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2145%;margin-top:-6.4px;left:78.6425%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,50 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-358" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2145%;margin-top:-6.4px;left:88.9379%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle35">5</span><span class="g-cstyle27">,</span>4<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-359" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2145%;margin-top:-6.4px;left:54.6508%;width:50px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>12 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-360" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2415%;margin-top:-5.9px;left:66.0656%;width:48px;">
      <p class="g-pstyle39"><span class="g-cstyle36">7</span><span class="g-cstyle37">4</span>,11%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-361" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.2321%;margin-top:-5.7px;left:3.2851%;width:31px;">
      <p class="g-pstyle38">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-362" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8365%;margin-top:-5.9px;left:9.1787%;width:95px;">
      <p class="g-pstyle29">P<span class="g-cstyle3">UC </span>de <span class="g-cstyle14">V</span>al<span class="g-cstyle3">p</span>a<span class="g-cstyle3">r</span>aís<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-363" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8636%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-364" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8635%;margin-top:-6.4px;left:78.6223%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-365" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8635%;margin-top:-6.4px;left:88.9184%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-366" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.9177%;margin-top:-6.4px;left:54.8327%;width:50px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle12">7</span>,<span class="g-cstyle2">5</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-367" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.9447%;margin-top:-5.9px;left:65.9643%;width:48px;">
      <p class="g-pstyle40"><span class="g-cstyle38">7</span><span class="g-cstyle39">4</span>,18%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-368" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8812%;margin-top:-5.7px;left:3.2241%;width:32px;">
      <p class="g-pstyle38">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-369" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5396%;margin-top:-5.9px;left:9.1787%;width:113px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> A<span class="g-cstyle2">dv</span>en<span class="g-cstyle2">ti</span>sta <span class="g-cstyle2">de</span> C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-370" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5666%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-371" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5667%;margin-top:-6.4px;left:79.4698%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span><span class="g-cstyle14">7</span>4<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-372" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5667%;margin-top:-6.4px;left:89.0593%;width:49px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>11<span class="g-cstyle20">,</span><span class="g-cstyle14">7</span><span class="g-cstyle3">4</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-373" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.6207%;margin-top:-6.4px;left:54.7313%;width:50px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle6">4</span><span class="g-cstyle2">,</span>13<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-374" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5937%;margin-top:-5.9px;left:65.985%;width:49px;">
      <p class="g-pstyle27">7<span class="g-cstyle41">9</span>,<span class="g-cstyle31">8</span>7%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-375" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.5843%;margin-top:-5.7px;left:3.2448%;width:33px;">
      <p class="g-pstyle38">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-376" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2428%;margin-top:-5.9px;left:9.1787%;width:105px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C<span class="g-cstyle7">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">d</span>el <span class="g-cstyle2">Ma</span>ule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-377" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2157%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-378" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2698%;margin-top:-6.4px;left:79.4295%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span>7<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-379" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2698%;margin-top:-6.4px;left:88.9379%;width:49px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2,</span>18 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-380" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2698%;margin-top:-6.4px;left:54.6508%;width:51px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle25">,</span>72 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-381" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2968%;margin-top:-5.9px;left:65.924%;width:49px;">
      <p class="g-pstyle41">7<span class="g-cstyle42">9</span><span class="g-cstyle23">,</span>66%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-382" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.2333%;margin-top:-5.7px;left:3.1637%;width:33px;">
      <p class="g-pstyle38">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-383" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.8918%;margin-top:-5.9px;left:9.1787%;width:110px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> C</span><span class="g-cstyle7">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>ica<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle15">T</span>e<span class="g-cstyle3">mu</span>co<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-384" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9188%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-385" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9188%;margin-top:-6.4px;left:79.4494%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span>79 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-386" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9188%;margin-top:-6.4px;left:88.8976%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,5<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-387" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9729%;margin-top:-6.4px;left:54.7313%;width:49px;">
      <p class="g-pstyle26"> 21<span class="g-cstyle2">,</span>1<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-388" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9458%;margin-top:-5.9px;left:65.9447%;width:49px;">
      <p class="g-pstyle42">76,85%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-389" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.9365%;margin-top:-5.7px;left:3.2448%;width:32px;">
      <p class="g-pstyle38">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-390" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.5949%;margin-top:-5.9px;left:9.1787%;width:122px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> C. R<span class="g-cstyle2">a</span>úl S<span class="g-cstyle2">i</span>l<span class="g-cstyle2">va</span> <span class="g-cstyle2">H</span>e<span class="g-cstyle2">n</span>r<span class="g-cstyle2">í</span>q<span class="g-cstyle2">u</span>e<span class="g-cstyle2">z</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-391" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.5678%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-392" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.6219%;margin-top:-6.4px;left:79.3285%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,5<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-393" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.6219%;margin-top:-6.4px;left:88.7365%;width:50px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle17">0</span><span class="g-cstyle10">,</span>88<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-394" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.6219%;margin-top:-6.4px;left:54.6309%;width:51px;">
      <p class="g-pstyle26"> 22<span class="g-cstyle2">,</span>4<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-395" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.649%;margin-top:-5.9px;left:66.0048%;width:49px;">
      <p class="g-pstyle32">7<span class="g-cstyle43">7</span>,49%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-396" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.5855%;margin-top:-5.7px;left:3.2039%;width:33px;">
      <p class="g-pstyle38">16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-397" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.244%;margin-top:-5.9px;left:9.1787%;width:85px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e L<span class="g-cstyle2">o</span>s<span class="g-cstyle2"> </span>L<span class="g-cstyle2">a</span>go<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-398" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.271%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-399" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.271%;margin-top:-6.4px;left:79.5299%;width:45px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span><span class="g-cstyle40">9</span><span class="g-cstyle27">,</span><span class="g-cstyle3">4</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-400" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.271%;margin-top:-6.4px;left:89.0795%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle20">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-401" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.3251%;margin-top:-6.4px;left:54.5904%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>58<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-402" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.298%;margin-top:-5.9px;left:65.9447%;width:49px;">
      <p class="g-pstyle42">76,58%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-403" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2886%;margin-top:-5.7px;left:3.2644%;width:32px;">
      <p class="g-pstyle38">17<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-404" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.9471%;margin-top:-5.9px;left:9.1787%;width:135px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Playa A. d<span class="g-cstyle2">e</span> C<span class="g-cstyle2">s</span>. <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> la</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-405" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.92%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-406" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.9741%;margin-top:-6.4px;left:79.4295%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle27">,</span>43 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-407" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.9741%;margin-top:-6.4px;left:88.8573%;width:51px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle44">3</span><span class="g-cstyle3">,2</span>8 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-408" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.9741%;margin-top:-6.4px;left:54.7115%;width:49px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle9">8</span>,<span class="g-cstyle2">18</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-409" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.0012%;margin-top:-5.9px;left:66.0451%;width:48px;">
      <p class="g-pstyle43">71,14%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-410" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.9377%;margin-top:-5.7px;left:3.2039%;width:33px;">
      <p class="g-pstyle38">18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-411" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5961%;margin-top:-5.9px;left:9.1787%;width:94px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3">T.</span>F.<span class="g-cstyle3"> S</span>an<span class="g-cstyle3">t</span>a<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">rí</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-412" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6231%;margin-top:-6.4px;left:40.1854%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">6</span> </p>
    </div>
    <div id="g-ai1-413" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6231%;margin-top:-6.4px;left:78.8445%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span>77 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-414" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6231%;margin-top:-6.4px;left:88.7768%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle45">6</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-415" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6772%;margin-top:-6.4px;left:54.5501%;width:52px;">
      <p class="g-pstyle26"> 3<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>24 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-416" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6502%;margin-top:-5.9px;left:65.9447%;width:49px;">
      <p class="g-pstyle42"><span class="g-cstyle15">7</span><span class="g-cstyle46">4</span>,22%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-417" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.6408%;margin-top:-5.7px;left:3.2039%;width:33px;">
      <p class="g-pstyle38">19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-418" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.2992%;margin-top:-5.9px;left:9.1787%;width:93px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e A<span class="g-cstyle2">n</span>t<span class="g-cstyle19">o</span>f<span class="g-cstyle2">a</span>g<span class="g-cstyle2">a</span>sta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-419" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.2722%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-420" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3263%;margin-top:-6.4px;left:78.6223%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>6 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-421" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3263%;margin-top:-6.4px;left:88.8976%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,32 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-422" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3263%;margin-top:-6.4px;left:54.6911%;width:51px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle17">9</span><span class="g-cstyle6">,</span>63<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-423" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3533%;margin-top:-5.9px;left:66.1059%;width:50px;">
      <p class="g-pstyle44">7<span class="g-cstyle47">7</span><span class="g-cstyle48">,</span>93%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-424" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.2898%;margin-top:-5.7px;left:3.1234%;width:34px;">
      <p class="g-pstyle38">20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-425" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9483%;margin-top:-5.9px;left:9.1787%;width:59px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>Ma<span class="g-cstyle3">y</span>o<span class="g-cstyle3">r</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-426" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9753%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-427" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9753%;margin-top:-6.4px;left:79.4896%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-428" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.9753%;margin-top:-6.4px;left:88.9184%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>7 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-429" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.0294%;margin-top:-6.4px;left:54.5501%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">3</span><span class="g-cstyle2">,</span>4<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-430" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.0023%;margin-top:-5.9px;left:66.0854%;width:49px;">
      <p class="g-pstyle45">7<span class="g-cstyle49">7</span><span class="g-cstyle29">,</span><span class="g-cstyle50">0</span>7%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-431" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.993%;margin-top:-5.7px;left:3.2241%;width:32px;">
      <p class="g-pstyle38">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-432" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6514%;margin-top:-5.9px;left:9.1787%;width:90px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>Mag<span class="g-cstyle3">a</span>l<span class="g-cstyle3">l</span>ane<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-433" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6243%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-434" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6784%;margin-top:-6.4px;left:79.349%;width:47px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle11">,</span><span class="g-cstyle2">9</span>9 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-435" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6784%;margin-top:-6.4px;left:88.8573%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle27">,</span>4<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-436" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.6785%;margin-top:-6.4px;left:54.7313%;width:49px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> 1</span><span class="g-cstyle6">4</span>,<span class="g-cstyle3">5</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-437" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.7055%;margin-top:-5.9px;left:65.9643%;width:49px;">
      <p class="g-pstyle40">6<span class="g-cstyle51">7</span>,86%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-438" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.642%;margin-top:-5.7px;left:3.1637%;width:34px;">
      <p class="g-pstyle38">22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-439" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3004%;margin-top:-5.9px;left:9.1787%;width:86px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle14">V</span>a<span class="g-cstyle3">l</span>pa<span class="g-cstyle3">r</span>a<span class="g-cstyle3">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-440" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3275%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-441" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3275%;margin-top:-6.4px;left:78.723%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,23 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-442" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3275%;margin-top:-6.4px;left:88.9782%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span><span class="g-cstyle20">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-443" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3815%;margin-top:-6.4px;left:54.7518%;width:50px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle9">8</span><span class="g-cstyle25">,</span>73 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-444" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3545%;margin-top:-5.9px;left:65.924%;width:49px;">
      <p class="g-pstyle41">72<span class="g-cstyle41">,</span>98%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-445" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3451%;margin-top:-5.7px;left:3.1838%;width:34px;">
      <p class="g-pstyle38">23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-446" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0036%;margin-top:-5.9px;left:9.1787%;width:114px;">
      <p class="g-pstyle24"><span class="g-cstyle2">U</span>C <span class="g-cstyle2">d</span>e<span class="g-cstyle2"> </span>la<span class="g-cstyle2"> </span>S. C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">c</span>ep<span class="g-cstyle2">ci</span>ón<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-447" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.9765%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-448" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0306%;margin-top:-6.4px;left:79.3688%;width:47px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,5<span class="g-cstyle2">4</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-449" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0306%;margin-top:-6.4px;left:88.8781%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2<span class="g-cstyle21">,</span><span class="g-cstyle2">6</span>3 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-450" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0306%;margin-top:-6.4px;left:54.6105%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">3</span><span class="g-cstyle6">,</span>68 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-451" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0577%;margin-top:-5.9px;left:65.985%;width:49px;">
      <p class="g-pstyle27">76<span class="g-cstyle23">,</span>79%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-452" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.9942%;margin-top:-5.7px;left:3.1234%;width:34px;">
      <p class="g-pstyle38">24<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-453" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6526%;margin-top:-5.9px;left:9.1787%;width:82px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>nd<span class="g-cstyle19">r</span><span class="g-cstyle3">é</span>s<span class="g-cstyle3"> </span>B<span class="g-cstyle3">e</span>l<span class="g-cstyle3">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-454" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6796%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-455" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6796%;margin-top:-6.4px;left:79.4091%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle27">,</span>42<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-456" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6796%;margin-top:-6.4px;left:88.8573%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">9</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-457" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.7338%;margin-top:-6.4px;left:54.6105%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">3</span><span class="g-cstyle6">,</span>66 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-458" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.7067%;margin-top:-5.9px;left:65.985%;width:49px;">
      <p class="g-pstyle27">72<span class="g-cstyle52">,</span>95%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-459" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.6973%;margin-top:-5.7px;left:3.1838%;width:34px;">
      <p class="g-pstyle38">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-460" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.3557%;margin-top:-5.9px;left:9.1787%;width:90px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> D</span>i<span class="g-cstyle3">e</span>go<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>r<span class="g-cstyle3">t</span>a<span class="g-cstyle3">l</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-461" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.3827%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-462" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.3827%;margin-top:-6.4px;left:79.3688%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,5<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-463" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.3827%;margin-top:-6.4px;left:88.8976%;width:50px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle20">,</span><span class="g-cstyle3">7</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-464" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.3827%;margin-top:-6.4px;left:54.5098%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle6">4</span><span class="g-cstyle10">,</span>64 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-465" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4098%;margin-top:-5.9px;left:66.0253%;width:50px;">
      <p class="g-pstyle35">76<span class="g-cstyle53">,</span>73%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-466" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4004%;margin-top:-5.7px;left:3.1429%;width:34px;">
      <p class="g-pstyle38">26<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-467" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0048%;margin-top:-5.9px;left:9.1787%;width:89px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>n <span class="g-cstyle2">S</span>eb<span class="g-cstyle2">as</span>t<span class="g-cstyle2">i</span>á<span class="g-cstyle2">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-468" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0318%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-469" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0318%;margin-top:-6.4px;left:79.3087%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle21">,</span>6<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-470" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0318%;margin-top:-6.4px;left:88.8976%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-471" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0859%;margin-top:-6.4px;left:54.6309%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle17">9</span>,8<span class="g-cstyle2">3</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-472" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0588%;margin-top:-5.9px;left:65.9038%;width:48px;">
      <p class="g-pstyle46">8<span class="g-cstyle32">0</span><span class="g-cstyle54">,</span>61%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-473" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0495%;margin-top:-5.7px;left:3.2036%;width:33px;">
      <p class="g-pstyle38">27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-474" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7079%;margin-top:-5.9px;left:9.1787%;width:76px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle20">-</span><span class="g-cstyle3">Bí</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-475" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7349%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-476" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7349%;margin-top:-6.4px;left:79.3892%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle11">,</span><span class="g-cstyle2">9</span>5 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-477" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7349%;margin-top:-6.4px;left:88.8372%;width:51px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle44">3</span><span class="g-cstyle3">,2</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-478" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7349%;margin-top:-6.4px;left:54.5904%;width:52px;">
      <p class="g-pstyle26"> 25<span class="g-cstyle10">,</span><span class="g-cstyle2">0</span>9<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-479" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.762%;margin-top:-5.9px;left:65.9643%;width:49px;">
      <p class="g-pstyle47"><span class="g-cstyle55">7</span><span class="g-cstyle53">4</span><span class="g-cstyle13">,</span>78%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-480" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.7526%;margin-top:-5.7px;left:3.1429%;width:34px;">
      <p class="g-pstyle38">28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-481" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3569%;margin-top:-5.9px;left:9.1787%;width:78px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Fi<span class="g-cstyle2">n</span>i<span class="g-cstyle2">s </span><span class="g-cstyle15">T</span>er<span class="g-cstyle2">ra</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-482" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3839%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-483" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3839%;margin-top:-6.4px;left:79.3688%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,5<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-484" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3839%;margin-top:-6.4px;left:88.9782%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">11</span><span class="g-cstyle21">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-485" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.438%;margin-top:-6.4px;left:54.5501%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle6">,</span>66 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-486" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.411%;margin-top:-5.9px;left:66.0253%;width:50px;">
      <p class="g-pstyle48">75<span class="g-cstyle56">,</span>52%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-487" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.4016%;margin-top:-5.7px;left:3.1429%;width:34px;">
      <p class="g-pstyle38">29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-488" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0601%;margin-top:-5.9px;left:9.1787%;width:82px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle13">T</span>a<span class="g-cstyle3">r</span>apa<span class="g-cstyle3">c</span>á<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-489" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0871%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-490" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0871%;margin-top:-6.4px;left:78.723%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,23 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-491" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0871%;margin-top:-6.4px;left:88.9184%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle35">5</span>,25<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-492" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.0871%;margin-top:-6.4px;left:54.7313%;width:50px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">8</span><span class="g-cstyle25">,</span>71 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-493" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1141%;margin-top:-5.9px;left:65.9447%;width:50px;">
      <p class="g-pstyle42">76,39%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-494" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.1047%;margin-top:-5.7px;left:3.1429%;width:34px;">
      <p class="g-pstyle38">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-495" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7091%;margin-top:-5.9px;left:9.1787%;width:107px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Aut<span class="g-cstyle2">ó</span>n<span class="g-cstyle2">o</span>m<span class="g-cstyle2">a</span> d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-496" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7361%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-497" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7361%;margin-top:-6.4px;left:79.5904%;width:45px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-498" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7361%;margin-top:-6.4px;left:88.7768%;width:50px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>1<span class="g-cstyle3">2</span><span class="g-cstyle20">,</span>08 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-499" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7902%;margin-top:-6.4px;left:54.6911%;width:52px;">
      <p class="g-pstyle26"> 25<span class="g-cstyle2">,</span>33 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-500" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7632%;margin-top:-5.9px;left:65.9038%;width:48px;">
      <p class="g-pstyle49">81,24%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-501" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7538%;margin-top:-5.7px;left:3.2448%;width:33px;">
      <p class="g-pstyle38">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-502" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4122%;margin-top:-5.9px;left:9.1787%;width:108px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Be<span class="g-cstyle2">r</span>n<span class="g-cstyle2">ardo</span> O<span class="g-cstyle2">&rsquo;</span>H<span class="g-cstyle2">i</span>ggin<span class="g-cstyle2">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-503" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4393%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-504" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4392%;margin-top:-6.4px;left:79.5904%;width:45px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle20">,</span>7<span class="g-cstyle2">1</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-505" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4392%;margin-top:-6.4px;left:88.8573%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,3<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-506" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4392%;margin-top:-6.4px;left:54.6105%;width:52px;">
      <p class="g-pstyle26"> 22<span class="g-cstyle2">,</span>29 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-507" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4663%;margin-top:-5.9px;left:65.9447%;width:50px;">
      <p class="g-pstyle33">76<span class="g-cstyle52">,</span>63%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-508" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.4569%;margin-top:-5.7px;left:3.1838%;width:34px;">
      <p class="g-pstyle38">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-509" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0613%;margin-top:-5.9px;left:9.1787%;width:85px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2"> </span>Se<span class="g-cstyle19">r</span>e<span class="g-cstyle2">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-510" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0883%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">5</span> </p>
    </div>
    <div id="g-ai1-511" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0883%;margin-top:-6.4px;left:78.8244%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span>,<span class="g-cstyle2">1</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-512" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0883%;margin-top:-6.4px;left:88.9782%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle35">5</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>1 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-513" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1424%;margin-top:-6.4px;left:54.5904%;width:52px;">
      <p class="g-pstyle26"> 26<span class="g-cstyle2">,</span>4<span class="g-cstyle2">7</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-514" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1695%;margin-top:-5.9px;left:65.8431%;width:49px;">
      <p class="g-pstyle50">66<span class="g-cstyle57">,</span>99%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-515" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1059%;margin-top:-5.7px;left:3.2036%;width:34px;">
      <p class="g-pstyle38">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-516" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7644%;margin-top:-5.9px;left:9.1787%;width:96px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>l<span class="g-cstyle3">b</span>e<span class="g-cstyle3">r</span>to<span class="g-cstyle3"> </span>H<span class="g-cstyle3">u</span>r<span class="g-cstyle3">t</span>ad<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-517" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7914%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-518" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7914%;margin-top:-6.4px;left:79.2879%;width:47px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle10">,</span>8<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-519" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.7914%;margin-top:-6.4px;left:88.9184%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">11</span><span class="g-cstyle10">,</span>84 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-520" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8455%;margin-top:-6.4px;left:54.7115%;width:51px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle12">7</span>,8<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-521" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8184%;margin-top:-5.9px;left:65.924%;width:49px;">
      <p class="g-pstyle51">6<span class="g-cstyle58">9</span>,52%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-522" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8091%;margin-top:-5.7px;left:3.1234%;width:34px;">
      <p class="g-pstyle38">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-523" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4134%;margin-top:-5.9px;left:9.1787%;width:98px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">d</span>e La<span class="g-cstyle2">s</span> Amé<span class="g-cstyle2">r</span>i<span class="g-cstyle2">ca</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-524" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4405%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-525" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4405%;margin-top:-6.4px;left:79.3285%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-526" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4405%;margin-top:-6.4px;left:89.0795%;width:48px;">
      <p class="g-pstyle30"><span class="g-cstyle3"> </span>11<span class="g-cstyle10">,</span>81<span class="g-cstyle3"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-527" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4945%;margin-top:-6.4px;left:54.6105%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">3</span><span class="g-cstyle2">,</span>42 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-528" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.5216%;margin-top:-5.9px;left:65.9643%;width:49px;">
      <p class="g-pstyle47">61<span class="g-cstyle46">,</span>95%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-529" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.4581%;margin-top:-5.7px;left:3.2036%;width:34px;">
      <p class="g-pstyle38">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-530" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1165%;margin-top:-5.9px;left:9.1787%;width:84px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> S<span class="g-cstyle2">a</span>nt<span class="g-cstyle2">o</span> <span class="g-cstyle15">T</span>om<span class="g-cstyle2">ás</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-531" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1436%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-532" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1436%;margin-top:-6.4px;left:79.3688%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle11">,</span><span class="g-cstyle2">9</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-533" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1436%;margin-top:-6.4px;left:88.8976%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle44">3</span><span class="g-cstyle21">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-534" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1977%;margin-top:-6.4px;left:54.5098%;width:52px;">
      <p class="g-pstyle26"> 22<span class="g-cstyle2">,</span>4<span class="g-cstyle2">4 </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-535" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1706%;margin-top:-5.9px;left:65.9038%;width:49px;">
      <p class="g-pstyle49">6<span class="g-cstyle59">9</span>,22%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-536" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1612%;margin-top:-5.7px;left:3.1637%;width:34px;">
      <p class="g-pstyle38">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-537" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7656%;margin-top:-5.9px;left:9.1787%;width:130px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> <span class="g-cstyle2">M</span>et<span class="g-cstyle19">r</span><span class="g-cstyle2">o.</span> <span class="g-cstyle2">d</span>e C<span class="g-cstyle2">s</span>. d<span class="g-cstyle2">e</span> l<span class="g-cstyle2">a</span> E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c</span>.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-538" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7926%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai1-539" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8467%;margin-top:-6.4px;left:78.5821%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-540" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8467%;margin-top:-6.4px;left:88.8976%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle44">3</span><span class="g-cstyle21">,</span>62 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-541" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8467%;margin-top:-6.4px;left:54.7115%;width:50px;">
      <p class="g-pstyle26"> 1<span class="g-cstyle2">5</span>,2<span class="g-cstyle2">2</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-542" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8737%;margin-top:-5.9px;left:65.8233%;width:49px;">
      <p class="g-pstyle52">6<span class="g-cstyle34">9</span><span class="g-cstyle60">,</span>60%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-543" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.8103%;margin-top:-5.7px;left:3.2241%;width:34px;">
      <p class="g-pstyle38">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-544" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4687%;margin-top:-5.9px;left:9.1787%;width:80px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span><span class="g-cstyle7">A</span>ta<span class="g-cstyle3">c</span>a<span class="g-cstyle3">m</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-545" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4957%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-546" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4957%;margin-top:-6.4px;left:78.6626%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>2 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-547" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.4957%;margin-top:-6.4px;left:88.7975%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle35">5</span><span class="g-cstyle20">,</span><span class="g-cstyle2">0</span>8 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-548" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.5498%;margin-top:-6.4px;left:54.5501%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle16">0</span><span class="g-cstyle2">,</span>4<span class="g-cstyle2">5</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-549" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.5228%;margin-top:-5.9px;left:65.8233%;width:49px;">
      <p class="g-pstyle53">65<span class="g-cstyle61">,</span>04%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-550" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.5134%;margin-top:-5.7px;left:3.1637%;width:34px;">
      <p class="g-pstyle38">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-551" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1718%;margin-top:-5.9px;left:9.1787%;width:102px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span><span class="g-cstyle15">Tec. </span>M<span class="g-cstyle3">et</span><span class="g-cstyle19">r</span>o<span class="g-cstyle3">po</span>li<span class="g-cstyle3">t</span>an<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-552" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1448%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-553" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1989%;margin-top:-6.4px;left:78.6828%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span><span class="g-cstyle17">0</span><span class="g-cstyle27">,</span>4<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-554" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1989%;margin-top:-6.4px;left:88.817%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,2<span class="g-cstyle2">0</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-555" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1989%;margin-top:-6.4px;left:54.6309%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle6">4</span><span class="g-cstyle2">,</span>5<span class="g-cstyle2">5</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-556" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2259%;margin-top:-5.9px;left:65.8025%;width:49px;">
      <p class="g-pstyle54">6<span class="g-cstyle59">8</span><span class="g-cstyle57">,</span>64%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-557" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.1624%;margin-top:-5.7px;left:3.1637%;width:34px;">
      <p class="g-pstyle38">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-558" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8209%;margin-top:-5.9px;left:9.1787%;width:95px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Ce<span class="g-cstyle2">nt</span>r<span class="g-cstyle2">a</span>l <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">il</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-559" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8479%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-560" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8479%;margin-top:-6.4px;left:79.3285%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle10">,</span>8<span class="g-cstyle2">6</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-561" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8479%;margin-top:-6.4px;left:88.8781%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,22<span class="g-cstyle2"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-562" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.902%;margin-top:-6.4px;left:54.5702%;width:52px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">8</span>,<span class="g-cstyle2">5</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-563" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8749%;margin-top:-5.9px;left:65.9038%;width:49px;">
      <p class="g-pstyle55">7<span class="g-cstyle55">3</span>,<span class="g-cstyle52">84</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-564" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.8656%;margin-top:-5.7px;left:3.0623%;width:34px;">
      <p class="g-pstyle38">40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-565" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.524%;margin-top:-5.9px;left:9.1787%;width:76px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> A</span>r<span class="g-cstyle3">t</span>u<span class="g-cstyle7">r</span>o <span class="g-cstyle3">P</span>r<span class="g-cstyle7">a</span>t<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-566" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.497%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-567" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.5511%;margin-top:-6.4px;left:79.3688%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle10">,</span>85 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-568" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.5511%;margin-top:-6.4px;left:88.8573%;width:51px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,39 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-569" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.551%;margin-top:-6.4px;left:54.6712%;width:51px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle9">8</span><span class="g-cstyle25">,</span>72 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-570" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.5781%;margin-top:-5.9px;left:65.8233%;width:49px;">
      <p class="g-pstyle56">6<span class="g-cstyle60">8</span>,20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-571" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.5146%;margin-top:-5.7px;left:3.1637%;width:33px;">
      <p class="g-pstyle38">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-572" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.173%;margin-top:-5.9px;left:9.1787%;width:105px;">
      <p class="g-pstyle24"><span class="g-cstyle5">U</span><span class="g-cstyle2">.</span> Ac. <span class="g-cstyle2">de</span> <span class="g-cstyle2">H. </span>Cri<span class="g-cstyle2">s</span>t<span class="g-cstyle2">ia</span>no<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-573" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2001%;margin-top:-6.4px;left:40.1452%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">4</span> </p>
    </div>
    <div id="g-ai1-574" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2001%;margin-top:-6.4px;left:79.3285%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span><span class="g-cstyle10">,</span>8<span class="g-cstyle2">9</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-575" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2001%;margin-top:-6.4px;left:88.8573%;width:50px;">
      <p class="g-pstyle26"> <span class="g-cstyle17">1</span><span class="g-cstyle24">4</span>,5<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-576" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2541%;margin-top:-6.4px;left:54.7921%;width:50px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle12">7</span><span class="g-cstyle25">,</span><span class="g-cstyle8">7</span>4 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-577" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2271%;margin-top:-5.9px;left:65.8635%;width:49px;">
      <p class="g-pstyle57">6<span class="g-cstyle32">4</span>,25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-578" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2177%;margin-top:-5.7px;left:3.1234%;width:34px;">
      <p class="g-pstyle38">42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-579" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8762%;margin-top:-5.9px;left:9.1787%;width:92px;">
      <p class="g-pstyle29"><span class="g-cstyle5">U</span>.<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e </span>V<span class="g-cstyle3">i</span>ña<span class="g-cstyle3"> </span>d<span class="g-cstyle3">e</span>l<span class="g-cstyle3"> </span>Ma<span class="g-cstyle1">r</span></p>
    </div>
    <div id="g-ai1-580" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8491%;margin-top:-6.4px;left:40.226%;width:30px;">
      <p class="g-pstyle25"><span class="g-cstyle3">3</span> </p>
    </div>
    <div id="g-ai1-581" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.9032%;margin-top:-6.4px;left:79.349%;width:46px;">
      <p class="g-pstyle26"> <span class="g-cstyle40">9</span>,2<span class="g-cstyle2">8</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-582" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.9032%;margin-top:-6.4px;left:88.9184%;width:49px;">
      <p class="g-pstyle26"> <span class="g-cstyle2">1</span>2,<span class="g-cstyle2">1</span>0 <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-583" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.9032%;margin-top:-6.4px;left:54.5501%;width:50px;">
      <p class="g-pstyle26"> 2<span class="g-cstyle6">4</span><span class="g-cstyle2">,</span>43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-584" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.9302%;margin-top:-5.9px;left:65.8635%;width:49px;">
      <p class="g-pstyle58">55,40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-585" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8668%;margin-top:-5.7px;left:3.1234%;width:32px;">
      <p class="g-pstyle28"><span class="g-cstyle4">4</span>3</p>
    </div>
    <div id="g-ai1-586" class="g-Layer_1 g-aiAbs" style="top:75.2344%;left:6.7242%;width:86.5625%;">
      <p>Fuente: www.mifuturo.cl, Mineduc // Indicadores: Años acreditados: siete años es el máximo que otorga la CNA, la fecha de cierre es el 10 de diciembre de 2021 / Estudiantes/JCE: entrega el número de estudiantes de pregrado y posgrado por el número de Jornadas Completas Equivalentes (JCE) del año 2021. Una JCE corresponde a 44 horas académicas contratadas a la semana por una institución / Retención de alumnos al 2&ordm; año: expresa al porcentaje de estudiantes que estando matriculados en una carrera como estudiantes de segundo año, continuaron matriculados en la misma institución y en la misma generación de origen al año siguiente, se utilizaron las cohortes 2018 y 2019, y solo se calcula cuando existen, al menos, 25 casos de las cohortes correspondientes / Duración programas en semestres: la duración formal de una carrera es la mínima esperada considerando el n&ordm; de semestres y la titulación, y la duración real es lo que tardaron los alumnos en titularse y se calcula con los estudiantes titulados en 2020// Referencia metodológica: en la tabla se aprecian las cifras que registran las instituciones en cada uno de los indicadores. Para obtener el índice ponderado, estas fueron normalizadas estadísticamente, reescalándolas respecto del máximo valor del parámetro. De esta manera, la institución que presenta el mejor desempeño en el indicador tiene 100 puntos. Se ponderó un 50% los años acreditados, un 20% estudiantes/JCE, un 15% retención de 2&ordm; año y un 15% la diferencia entre la duración formal y real de los programas expresados en semestres.// (*) La U. Adventista de Chile ingresa por primera vez al Ranking de Universidades // En este ranking no se registra la información de las universidades Gabriela Mistral, de Aconcagua, del Alba, ex U. Pedro de Valdivia, Miguel de Cervantes y Bolivariana, ya que no poseen acreditación, a ellas se suman la UNIACC e Internacional SEK, que si bien cuentan con 3 años de acreditación cada una, sus umbrales de investigación son incipientes, por lo que no es posible incluirla en el Ranking de Universidades. </p>
    </div>
  </div>


</div>
`

const containerId = 'g-calidad-de-la-gestion-box'
const namespace = 'g-'
const name = 'calidad-de-la-gestion'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-20 14:43 */
